import React from "react";
import { Modal } from "reactstrap";
import "assets/css/safexpay-web.css";
import "./Registration.css";
import uploadImg from "../../assets/img/icons/upload.png";
import documentImgIcon from "../../assets/img/icons/ufile.png";
import Spinner from "reactstrap/lib/Spinner";
import { base_url, client_Id, client_Secret } from "assets/utils/const";
import {
  CINValidation,
  DINValidation,
  GSTINValidation,
  UaadharValidation,
  FSSAIValidation,
} from "assets/utils/constFuntion";

class BusinessDoc extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fileFront: null,
      fileBack: null,
      filePan: null,
      individualddlAddress: null,
      proprietorddlAddress: null,
      partnerd1ddlAddress: null,
      partnerd2ddlAddress: null,
      publicd1ddlAddress: null,
      publicd2ddlAddress: null,
      trustd1ddlAddress: null,
      trustd2ddlAddress: null,
      isGstAvailable: "yes",
      submit: false,
      isLoaded: false,
      fileSizeError1: false,
      fileSizeError2: false,
      imageUploadedError1: false,
      imageUploadedError2: false,
      authToken: localStorage.getItem("Authtoken"),
      btype: "",
      meId: "",
      foodCat: "",
      cinError: false,
      dinError: false,
      gstError: false,
      udhaarError: false,
      fssaiError: false,
      fileSizeErrorMsg: "",
      moaFileName: "",
      aoaFileName: "",
      brFileName: "",
      deedFileName: "",
      tacFileName: "",
      fileUploadError: false,
      CINErrorResponse: false,
      GSTINErrorResponse: false,
      DINErrorResponse: false,
      foodErrorResponse: false,
      udyogErrorResponse: false,
    };
    this.individualGstPreview = this.individualGstPreview.bind(this);
    this.individualPanPreview = this.individualPanPreview.bind(this);
    this.individualUdyogAadhaarPreviewFront =
      this.individualUdyogAadhaarPreviewFront.bind(this);
    this.individualUdyogAadhaarPreviewBack =
      this.individualUdyogAadhaarPreviewBack.bind(this);
    this.individualFoodPreview = this.individualFoodPreview.bind(this);

    this.proprietorGstPreview = this.proprietorGstPreview.bind(this);
    this.proprietorPanPreview = this.proprietorPanPreview.bind(this);
    this.proprietorUdyogAadhaarPreviewFront =
      this.proprietorUdyogAadhaarPreviewFront.bind(this);
    this.proprietorUdyogAadhaarPreviewBack =
      this.proprietorUdyogAadhaarPreviewBack.bind(this);
    this.proprietorFoodPreview = this.proprietorFoodPreview.bind(this);

    this.partnerGstPreview = this.partnerGstPreview.bind(this);
    this.partnerPanPreview = this.partnerPanPreview.bind(this);
    this.partnerDeedPreview = this.partnerDeedPreview.bind(this);
    this.partnerCINPreviewFront = this.partnerCINPreviewFront.bind(this);
    this.partnerFoodPreview = this.partnerFoodPreview.bind(this);

    this.publicGstPreview = this.publicGstPreview.bind(this);
    this.publicPanPreview = this.publicPanPreview.bind(this);
    this.publicBRPreview = this.publicBRPreview.bind(this);
    this.publicCINPreviewFront = this.publicCINPreviewFront.bind(this);
    this.publicDINPreviewFront = this.publicDINPreviewFront.bind(this);
    this.publicMOAPreview = this.publicMOAPreview.bind(this);
    this.publicAOAPreview = this.publicAOAPreview.bind(this);
    this.publicUdyogAadhaarPreviewFront =
      this.publicUdyogAadhaarPreviewFront.bind(this);
    this.publicUdyogAadhaarPreviewBack =
      this.publicUdyogAadhaarPreviewBack.bind(this);
    this.publicFoodPreview = this.publicFoodPreview.bind(this);

    this.socialGstPreview = this.socialGstPreview.bind(this);
    this.socialPanPreview = this.socialPanPreview.bind(this);
    this.socialTACPreview = this.socialTACPreview.bind(this);
    this.socialBRPreview = this.socialBRPreview.bind(this);
    this.socialDeedPreview = this.socialDeedPreview.bind(this);
    this.socialFoodPreview = this.socialFoodPreview.bind(this);

    let individualGst = false;
    let individualPan = false;
    let individualUdyogAadhaar = false;

    let proprietorGst = false;
    let proprietorPan = false;
    let proprietorUdyogAadhaar = false;

    let partnerGst = false;
    let partnerPan = false;
    let partnerDeed = false;
    let partnerCIN = false;

    let publicGst = false;
    let publicPan = false;
    let publicBR = false;
    let publicCIN = false;
    let publicDIN = false;
    let publicMOA = false;
    let publicAOA = false;
    let publicUdyogAadhaar = false;

    let socialGst = false;
    let socialPan = false;
    let socialTAC = false;
    let socialBR = false;
    let socialDeed = false;
  }

  componentDidMount() {
    if (!localStorage.getItem("Authtoken")) {
      window.location.href = "/login";
    }
    fetch(`${base_url}api/dmoAuthApi`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods":
          "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: this.state.authToken,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.statusCode == "200") {
          const payloadDetails = JSON.parse(result.payLoad);
          this.setState({
            btype: payloadDetails.BusinessType,
            meId: payloadDetails.meId,
            foodCat: payloadDetails.category,
          });
          this.initialData();
        } else {
          if (
            result.payLoad === `Session Expired Please Login` ||
            result.payLoad === `Incorrect Token`
          ) {
            this.toggleModal("loginModal");
          }
        }
      });
  }

  handleLogin = () => {
    this.toggleModal("loginModal");
    window.location.href = "/login";
  };

  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
      fileSizeError1: false,
      fileSizeErrorMsg: "",
      imageUploadedError1: false,
      imageUploadedError2: false,
      submit: false,
      fileUploadError: false,
      CINErrorResponse: false,
      GSTINErrorResponse: false,
      DINErrorResponse: false,
      foodErrorResponse: false,
      udyogErrorResponse: false,
    });
  };
  handleCloseModal = (e, key) => {
    e.preventDefault();
    this.toggleModal(key);
  };
  initialData() {
    const { btype } = this.state;
    if (btype === "Proprietorship") {
      if (localStorage.getItem("GST")) {
        this.proprGst();
      }
      if (localStorage.getItem("Company Pan Card")) {
        this.propCompanyPan();
      }
      if (localStorage.getItem("UAADHAAR")) {
        this.propUAadhaar();
      }
      if (localStorage.getItem("FSSAI")) {
        this.propFood();
      }
    } else if (btype === "Partnership/LLP") {
      if (localStorage.getItem("GST")) {
        this.partnerIniGst();
      }
      if (localStorage.getItem("Company Pan Card")) {
        this.partnerCompanyPan();
      }
      if (localStorage.getItem("Paternership Deed")) {
        this.partDeed();
      }
      if (localStorage.getItem("CIN")) {
        this.partCIN();
      }
      if (localStorage.getItem("FSSAI")) {
        this.partFood();
      }
    } else if (btype === "PrivateLtd./PublicLtd.") {
      if (localStorage.getItem("GST")) {
        this.publicIniGst();
      }
      if (localStorage.getItem("Company Pan Card")) {
        this.publicIniCompanyPan();
      }
      if (localStorage.getItem("Board Resolution")) {
        this.publicIniBoard();
      }
      if (localStorage.getItem("CIN")) {
        this.publicIniCin();
      }
      if (localStorage.getItem("DIN")) {
        this.publicIniDin();
      }
      if (localStorage.getItem("Memorandum of Association")) {
        this.publicIniMemo();
      }
      if (localStorage.getItem("Article of Associations")) {
        this.publicIniArt();
      }
      if (localStorage.getItem("UAADHAAR")) {
        this.publicIniUAadhaar();
      }
      if (localStorage.getItem("FSSAI")) {
        this.publicIniFood();
      }
    } else if (btype === "Trust/Society") {
      if (localStorage.getItem("GST")) {
        this.societyGst();
      }
      if (localStorage.getItem("Company Pan Card")) {
        this.societyCompanyPan();
      }
      if (localStorage.getItem("Trust Act Certificate")) {
        this.societyTrust();
      }
      if (localStorage.getItem("Authorization Letter Or Board Resolution")) {
        this.societyAuth();
      }
      if (localStorage.getItem("Trust Deed")) {
        this.societyDeed();
      }
      if (localStorage.getItem("FSSAI")) {
        this.societyFood();
      }
    }
  }
  proprGst() {
    var txtproprietorGstCount = document.getElementById(
      "txtproprietorGstCount"
    );
    var btnproprietorGst = document.getElementById("btnproprietorGst");
    txtproprietorGstCount.value = 1;
    btnproprietorGst.disabled = true;
    btnproprietorGst.style.background = "#2faa4a";
    btnproprietorGst.innerText = "UPLOADED";
  }
  propCompanyPan() {
    var txtproprietorPanCount = document.getElementById(
      "txtproprietorPanCount"
    );
    var btnproprietorPan = document.getElementById("btnproprietorPan");
    txtproprietorPanCount.value = 1;
    btnproprietorPan.disabled = true;
    btnproprietorPan.style.background = "#2faa4a";
    btnproprietorPan.innerText = "UPLOADED";
  }
  propUAadhaar() {
    var txtproprietorUdyogAadhaarCount = document.getElementById(
      "txtproprietorUdyogAadhaarCount"
    );
    var btnproprietorUdyogAadhaar = document.getElementById(
      "btnproprietorUdyogAadhaar"
    );
    txtproprietorUdyogAadhaarCount.value = 1;
    btnproprietorUdyogAadhaar.disabled = true;
    btnproprietorUdyogAadhaar.style.background = "#2faa4a";
    btnproprietorUdyogAadhaar.innerText = "UPLOADED";
  }
  propFood() {
    var txtproprietorFoodCount = document.getElementById(
      "txtproprietorFoodCount"
    );
    var btnproprietorFood = document.getElementById("btnproprietorFood");
    txtproprietorFoodCount.value = 1;
    btnproprietorFood.disabled = true;
    btnproprietorFood.style.background = "#2faa4a";
    btnproprietorFood.innerText = "UPLOADED";
  }
  partnerIniGst() {
    var txtpartnerGstCount = document.getElementById("txtpartnerGstCount");
    var btnpartnerGst = document.getElementById("btnpartnerGst");
    txtpartnerGstCount.value = 1;
    btnpartnerGst.disabled = true;
    btnpartnerGst.style.background = "#2faa4a";
    btnpartnerGst.innerText = "UPLOADED";
  }
  partnerCompanyPan() {
    var txtpartnerPanCount = document.getElementById("txtpartnerPanCount");
    var btnpartnerPan = document.getElementById("btnpartnerPan");
    txtpartnerPanCount.value = 1;
    btnpartnerPan.disabled = true;
    btnpartnerPan.style.background = "#2faa4a";
    btnpartnerPan.innerText = "UPLOADED";
  }
  partDeed() {
    var txtpartnerDeedCount = document.getElementById("txtpartnerDeedCount");
    var btnpartnerDeed = document.getElementById("btnpartnerDeed");
    txtpartnerDeedCount.value = 1;
    btnpartnerDeed.disabled = true;
    btnpartnerDeed.style.background = "#2faa4a";
    btnpartnerDeed.innerText = "UPLOADED";
  }
  partCIN() {
    var txtpartnerCINCount = document.getElementById("txtpartnerCINCount");
    var btnpartnerCIN = document.getElementById("btnpartnerCIN");
    txtpartnerCINCount.value = 1;
    btnpartnerCIN.disabled = true;
    btnpartnerCIN.style.background = "#2faa4a";
    btnpartnerCIN.innerText = "UPLOADED";
  }
  partFood() {
    var txtpartnerFoodCount = document.getElementById("txtpartnerFoodCount");
    var btnpartnerFood = document.getElementById("btnpartnerFood");
    txtpartnerFoodCount.value = 1;
    btnpartnerFood.disabled = true;
    btnpartnerFood.style.background = "#2faa4a";
    btnpartnerFood.innerText = "UPLOADED";
  }
  publicIniGst() {
    var txtpublicGstCount = document.getElementById("txtpublicGstCount");
    var btnpublicGst = document.getElementById("btnpublicGst");
    txtpublicGstCount.value = 1;
    btnpublicGst.disabled = true;
    btnpublicGst.style.background = "#2faa4a";
    btnpublicGst.innerText = "UPLOADED";
  }
  publicIniBoard() {
    var txtpublicBRCount = document.getElementById("txtpublicBRCount");
    var btnpublicBR = document.getElementById("btnpublicBR");
    txtpublicBRCount.value = 1;
    btnpublicBR.disabled = true;
    btnpublicBR.style.background = "#2faa4a";
    btnpublicBR.innerText = "UPLOADED";
  }
  publicIniCin() {
    var txtpublicCINCount = document.getElementById("txtpublicCINCount");
    var btnpublicCIN = document.getElementById("btnpublicCIN");
    txtpublicCINCount.value = 1;
    btnpublicCIN.disabled = true;
    btnpublicCIN.style.background = "#2faa4a";
    btnpublicCIN.innerText = "UPLOADED";
  }
  publicIniDin() {
    var txtpublicDINCount = document.getElementById("txtpublicDINCount");
    var btnpublicDIN = document.getElementById("btnpublicDIN");
    txtpublicDINCount.value = 1;
    btnpublicDIN.disabled = true;
    btnpublicDIN.style.background = "#2faa4a";
    btnpublicDIN.innerText = "UPLOADED";
  }
  publicIniMemo() {
    var txtpublicMOACount = document.getElementById("txtpublicMOACount");
    var btnpublicMOA = document.getElementById("btnpublicMOA");
    txtpublicMOACount.value = 1;
    btnpublicMOA.disabled = true;
    btnpublicMOA.style.background = "#2faa4a";
    btnpublicMOA.innerText = "UPLOADED";
  }
  publicIniArt() {
    var txtpublicAOACount = document.getElementById("txtpublicAOACount");
    var btnpublicAOA = document.getElementById("btnpublicAOA");
    txtpublicAOACount.value = 1;
    btnpublicAOA.disabled = true;
    btnpublicAOA.style.background = "#2faa4a";
    btnpublicAOA.innerText = "UPLOADED";
  }
  publicIniCompanyPan() {
    var txtpublicPanCount = document.getElementById("txtpublicPanCount");
    var btnpublicPan = document.getElementById("btnpublicPan");
    txtpublicPanCount.value = 1;
    btnpublicPan.disabled = true;
    btnpublicPan.style.background = "#2faa4a";
    btnpublicPan.innerText = "UPLOADED";
  }
  publicIniUAadhaar() {
    var txtpublicUdyogAadhaarCount = document.getElementById(
      "txtpublicUdyogAadhaarCount"
    );
    var btnpublicUdyogAadhaar = document.getElementById(
      "btnpublicUdyogAadhaar"
    );
    txtpublicUdyogAadhaarCount.value = 1;
    btnpublicUdyogAadhaar.disabled = true;
    btnpublicUdyogAadhaar.style.background = "#2faa4a";
    btnpublicUdyogAadhaar.innerText = "UPLOADED";
  }
  publicIniFood() {
    var txtpublicFoodCount = document.getElementById("txtpublicFoodCount");
    var btnpublicFood = document.getElementById("btnpublicFood");
    txtpublicFoodCount.value = 1;
    btnpublicFood.disabled = true;
    btnpublicFood.style.background = "#2faa4a";
    btnpublicFood.innerText = "UPLOADED";
  }
  societyGst() {
    var txtsocialGstCount = document.getElementById("txtsocialGstCount");
    var btnsocialGst = document.getElementById("btnsocialGst");
    txtsocialGstCount.value = 1;
    btnsocialGst.disabled = true;
    btnsocialGst.style.background = "#2faa4a";
    btnsocialGst.innerText = "UPLOADED";
  }
  societyCompanyPan() {
    var txtsocialPanCount = document.getElementById("txtsocialPanCount");
    var btnsocialPan = document.getElementById("btnsocialPan");
    txtsocialPanCount.value = 1;
    btnsocialPan.disabled = true;
    btnsocialPan.style.background = "#2faa4a";
    btnsocialPan.innerText = "UPLOADED";
  }
  societyTrust() {
    var txtsocialTACCount = document.getElementById("txtsocialTACCount");
    var btnsocialTAC = document.getElementById("btnsocialTAC");
    txtsocialTACCount.value = 1;
    btnsocialTAC.disabled = true;
    btnsocialTAC.style.background = "#2faa4a";
    btnsocialTAC.innerText = "UPLOADED";
  }
  societyAuth() {
    var txtsocialBRCount = document.getElementById("txtsocialBRCount");
    var btnsocialBR = document.getElementById("btnsocialBR");
    txtsocialBRCount.value = 1;
    btnsocialBR.disabled = true;
    btnsocialBR.style.background = "#2faa4a";
    btnsocialBR.innerText = "UPLOADED";
  }
  societyDeed() {
    var txtsocialDeedCount = document.getElementById("txtsocialDeedCount");
    var btnsocialDeed = document.getElementById("btnsocialDeed");
    txtsocialDeedCount.value = 1;
    btnsocialDeed.disabled = true;
    btnsocialDeed.style.background = "#2faa4a";
    btnsocialDeed.innerText = "UPLOADED";
  }
  societyFood() {
    var txtsocialFoodCount = document.getElementById("txtsocialFoodCount");
    var btnsocialFood = document.getElementById("btnsocialFood");
    txtsocialFoodCount.value = 1;
    btnsocialFood.disabled = true;
    btnsocialFood.style.background = "#2faa4a";
    btnsocialFood.innerText = "UPLOADED";
  }
  individualGstPreview(event) {
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          individualGstFile: URL.createObjectURL(event.target.files[0]),
          fileSizeError1: false,
          fileSizeErrorMsg: "",
        });
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          document.getElementById("lblindividualGstFIle").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }

  individualPanPreview(event) {
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          individualPanFile: URL.createObjectURL(event.target.files[0]),
          fileSizeError1: false,
          fileSizeErrorMsg: "",
        });
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          document.getElementById("lblindividualPanFile").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  individualUdyogAadhaarPreviewFront(event) {
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          individualUdyogAadhaarFileFront: URL.createObjectURL(
            event.target.files[0]
          ),
          fileSizeError1: false,
          fileSizeErrorMsg: "",
        });
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          document.getElementById(
            "lblindividualUdyogAadhaarFileFront"
          ).innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  individualUdyogAadhaarPreviewBack(event) {
    this.setState({
      individualUdyogAadhaarFileBack: URL.createObjectURL(
        event.target.files[0]
      ),
    });

    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({ fileSizeError2: true });
        return false;
      } else {
        this.setState({
          individualUdyogAadhaarFileBack: URL.createObjectURL(
            event.target.files[0]
          ),
          fileSizeError2: false,
        });
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          document.getElementById(
            "lblindividualUdyogAadhaarFileBack"
          ).innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  individualFoodPreview(event) {
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          individualFoodFile: URL.createObjectURL(event.target.files[0]),
          fileSizeError1: false,
          fileSizeErrorMsg: "",
        });
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          document.getElementById("lblindividualFoodFIle").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  proprietorGstPreview(event) {
    this.setState({ proprietorGstFile: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            proprietorGstFile: `data:${file.type};base64 ,` + base64,
          });
          document.getElementById("lblproprietorGstFile").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  proprietorPanPreview(event) {
    this.setState({ proprietorPanFile: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg: "",
        });

        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            proprietorPanFile: `data:${file.type};base64 ,` + base64,
          });
          document.getElementById("lblproprietorPanFile").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  proprietorUdyogAadhaarPreviewFront(event) {
    this.setState({ proprietorUdyogAadhaarFileFront: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            proprietorUdyogAadhaarFileFront:
              `data:${file.type};base64 ,` + base64,
          });
          document.getElementById(
            "lblproprietorUdyogAadhaarFileFront"
          ).innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  proprietorUdyogAadhaarPreviewBack(event) {
    this.setState({ proprietorUdyogAadhaarFileBack: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({ fileSizeError2: true });
        return false;
      } else {
        this.setState({
          fileSizeError2: false,
          fileSizeErrorMsg: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            proprietorUdyogAadhaarFileBack:
              `data:${file.type};base64 ,` + base64,
          });
          document.getElementById(
            "lblproprietorUdyogAadhaarFileBack"
          ).innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  proprietorFoodPreview(event) {
    this.setState({ proprietorFoodFile: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg: "",
        });

        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            proprietorFoodFile: `data:${file.type};base64 ,` + base64,
          });
          document.getElementById("lblproprietorFoodFile").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }

  partnerGstPreview(event) {
    this.setState({ partnerGstFile: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg: "",
        });

        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            partnerGstFile: `data:${file.type};base64 ,` + base64,
          });
          document.getElementById("lblpartnerGstFile").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  partnerPanPreview(event) {
    this.setState({ partnerPanFile: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg: "",
        });

        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            partnerPanFile: `data:${file.type};base64 ,` + base64,
          });
          document.getElementById("lblpartnerPanFile").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  partnerDeedPreview(event) {
    this.setState({ partnerDeedFile: "", deedFileName: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "application/pdf" ||
        file.type === "application/msword" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document")
    ) {
      let fileType = "";
      if (file.type === "application/pdf") {
        fileType = "application/pdf";
      } else if (file.type === "application/msword") {
        fileType = "application/doc";
      } else {
        fileType = "application/docx";
      }
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg: "",
          deedFileName: file.name,
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            partnerDeedFile: `data:${fileType};base64,` + base64,
          });
          document.getElementById("lblpartnerDeedFile").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  partnerCINPreviewFront(event) {
    this.setState({ partnerCINFileFront: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            partnerCINFileFront: `data:${file.type};base64 ,` + base64,
          });
          document.getElementById("lblpartnerCINFileFront").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  partnerFoodPreview(event) {
    this.setState({ partnerFoodFile: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            partnerFoodFile: `data:${file.type};base64 ,` + base64,
          });
          document.getElementById("lblpartnerFoodFile").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }

  publicGstPreview(event) {
    this.setState({ publicGstFile: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg: "",
        });

        const reader = new FileReader();
        reader.readAsBinaryString(file);
        let el = this;
        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({ publicGstFile: `data:${file.type};base64 ,` + base64 });
          document.getElementById("lblpublicGstFile").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  publicPanPreview(event) {
    this.setState({ publicPanFile: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg: "",
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({ publicPanFile: `data:${file.type};base64 ,` + base64 });
          document.getElementById("lblpublicPanFile").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  publicBRPreview(event) {
    this.setState({ publicBRFile: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "application/pdf" ||
        file.type === "application/msword" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document")
    ) {
      let fileType = "";
      if (file.type === "application/pdf") {
        fileType = "application/pdf";
      } else if (file.type === "application/msword") {
        fileType = "application/doc";
      } else {
        fileType = "application/docx";
      }
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg: "",
          brFileName: file.name,
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);

          el.setState({
            publicBRFile: `data:${fileType};base64,` + base64,
          });
          document.getElementById("lblpublicBRFile").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  publicCINPreviewFront(event) {
    this.setState({ publicCINFileFront: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg: "",
        });

        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            publicCINFileFront: `data:${file.type};base64 ,` + base64,
          });
          document.getElementById("lblpublicCINFileFront").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  publicDINPreviewFront(event) {
    this.setState({ publicDINFileFront: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg: "",
        });

        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            publicDINFileFront: `data:${file.type};base64 ,` + base64,
          });
          document.getElementById("lblpublicDINFileFront").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  publicMOAPreview(event) {
    this.setState({ publicMOAFile: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "application/pdf" ||
        file.type === "application/msword" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document")
    ) {
      let fileType = "";
      if (file.type === "application/pdf") {
        fileType = "application/pdf";
      } else if (file.type === "application/msword") {
        fileType = "application/doc";
      } else {
        fileType = "application/docx";
      }
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg: "",
          moaFileName: file.name,
        });

        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({ publicMOAFile: `data:${fileType};base64,` + base64 });
          document.getElementById("lblpublicMOAFile").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  publicAOAPreview(event) {
    this.setState({ publicAOAFile: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "application/pdf" ||
        file.type === "application/msword" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document")
    ) {
      let fileType = "";
      if (file.type === "application/pdf") {
        fileType = "application/pdf";
      } else if (file.type === "application/msword") {
        fileType = "application/doc";
      } else {
        fileType = "application/docx";
      }
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg: "",
          aoaFileName: file.name,
        });
        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({ publicAOAFile: `data:${fileType};base64,` + base64 });
          document.getElementById("lblpublicAOAFile").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  publicUdyogAadhaarPreviewFront(event) {
    this.setState({ publicUdyogAadhaarFileFront: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg: "",
        });

        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            publicUdyogAadhaarFileFront: `data:${file.type};base64 ,` + base64,
          });
          document.getElementById("lblpublicUdyogAadhaarFileFront").innerText =
            base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  publicUdyogAadhaarPreviewBack(event) {
    this.setState({ publicUdyogAadhaarFileBack: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({ fileSizeError2: true });
        return false;
      } else {
        this.setState({
          publicUdyogAadhaarFileBack: URL.createObjectURL(
            event.target.files[0]
          ),
          fileSizeError2: false,
        });

        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            publicUdyogAadhaarFileBack: `data:${file.type};base64 ,` + base64,
          });
          document.getElementById("lblpublicUdyogAadhaarFileBack").innerText =
            base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  publicFoodPreview(event) {
    this.setState({ publicFoodFile: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg: "",
        });

        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            publicFoodFile: `data:${file.type};base64 ,` + base64,
          });
          document.getElementById("lblpublicFoodFile").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }

  socialGstPreview(event) {
    this.setState({ socialGstFile: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg: "",
        });

        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({ socialGstFile: `data:${file.type};base64 ,` + base64 });
          document.getElementById("lblsocialGstFile").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  socialPanPreview(event) {
    this.setState({ socialPanFile: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg: "",
        });

        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({ socialPanFile: `data:${file.type};base64 ,` + base64 });
          document.getElementById("lblsocialPanFile").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  socialTACPreview(event) {
    this.setState({ socialTACFile: "", tacFileName: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "application/pdf" ||
        file.type === "application/msword" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg: "",
          tacFileName: file.name,
        });

        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({ socialTACFile: `data:${file.type};base64,` + base64 });
          document.getElementById("lblsocialTACFile").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  socialBRPreview(event) {
    this.setState({ socialBRFile: "", brFileName: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "application/pdf" ||
        file.type === "application/msword" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document")
    ) {
      let fileType = "";
      if (file.type === "application/pdf") {
        fileType = "application/pdf";
      } else if (file.type === "application/msword") {
        fileType = "application/doc";
      } else {
        fileType = "application/docx";
      }
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg: "",
          brFileName: file.name,
        });

        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({ socialBRFile: `data:${fileType};base64,` + base64 });
          document.getElementById("lblsocialBRFile").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  socialDeedPreview(event) {
    this.setState({ socialDeedFile: "", deedFileName: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "application/pdf" ||
        file.type === "application/msword" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg: "",
          deedFileName: file.name,
        });

        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({ socialDeedFile: `data:${file.type};base64,` + base64 });
          document.getElementById("lblsocialDeedFile").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }
  socialFoodPreview(event) {
    this.setState({ socialFoodFile: "" });
    let file = event.target.files[0];
    if (
      file &&
      (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg")
    ) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > 2048) {
        this.setState({
          fileSizeError1: true,
          fileSizeErrorMsg: `${file.name} exceeds the maximum upload size for this file.`,
        });
        return false;
      } else {
        this.setState({
          fileSizeError1: false,
          fileSizeErrorMsg: "",
        });

        const el = this;
        const reader = new FileReader();
        reader.readAsBinaryString(file);

        reader.onload = function () {
          let base64 = btoa(reader.result);
          el.setState({
            socialFoodFile: `data:${file.type};base64 ,` + base64,
          });
          document.getElementById("lblsocialFoodFile").innerText = base64;
        };
        reader.onerror = function () {
          console.log("there are some problem");
        };
      }
    }
  }

  individualGst = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var udocument = document.getElementById("lblindividualGstFIle");
    var uidno = document.getElementById("txtgstno-modal").value;
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Individual";
    var udocumenttype = "business document";
    var furl = "data:image/png;base64 ," + udocument.innerText;
    var txtindividualGstCount = document.getElementById(
      "txtindividualGstCount"
    );
    var btnindividualGst = document.getElementById("btnindividualGst");

    if (udocument.innerText === "") {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    if (uidno === "") {
      this.setState({ imageUploadedError2: true });
      return false;
    } else {
      this.setState({ imageUploadedError2: false });
    }
    this.setState({ isLoaded: true, GSTINErrorResponse: false });

    fetch(`${base_url}api/digioGstApi`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        document: furl,
        idNo: uidno,
        business_type: ubusinestype,
        me_id: this.state.meId,
        document_type: udocumenttype,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            txtindividualGstCount.value = 1;
            btnindividualGst.disabled = true;
            btnindividualGst.style.background = "#2faa4a";
            btnindividualGst.innerText = "UPLOADED";
            this.setState({ submit: true });
          } else {
            this.setState({ GSTINErrorResponse: true });
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };

  individualFood = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var udocument = document.getElementById("lblindividualFoodFIle");
    var uidno = document.getElementById("txtfoodno-modal").value;
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Individual";
    var udocumenttype = "business document";
    var furl = "data:image/png;base64 ," + udocument.innerText;
    var txtindividualFoodCount = document.getElementById(
      "txtindividualFoodCount"
    );
    var btnindividualFood = document.getElementById("btnindividualFood");

    if (udocument.innerText === "") {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    if (uidno === "") {
      this.setState({ imageUploadedError2: true });
      return false;
    } else {
      this.setState({ imageUploadedError2: false });
    }
    this.setState({ isLoaded: true, foodErrorResponse: false });

    fetch(`${base_url}api/digioBusinessapi/FSSAI`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        document: furl,
        idNo: uidno,
        business_type: ubusinestype,
        me_id: this.state.meId,
        document_type: udocumenttype,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            txtindividualFoodCount.value = 1;
            btnindividualFood.disabled = true;
            btnindividualFood.style.background = "#2faa4a";
            btnindividualFood.innerText = "UPLOADED";
            this.setState({ submit: true });
          } else {
            this.setState({ foodErrorResponse: true });
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };

  individualPan = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var upan = document.getElementById("lblindividualPanFile"); //this.state.fileFront;
    var ubackpart = "blank";
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Individual"; //localStorage.getItem('cat');
    var udocumenttype = "business document";
    var udocumenttypename = "Company Pan Card";
    var furl = "data:image/png;base64 ," + upan.innerText;
    var txtindividualPanCount = document.getElementById(
      "txtindividualPanCount"
    );
    var btnindividualPan = document.getElementById("btnindividualPan");

    if (upan.innerText === "") {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    this.setState({ isLoaded: true });

    fetch(`${base_url}api/digio/documentUpload`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        front_part: furl,
        back_part: ubackpart,
        unique_request_id: uuniquerequestid,
        should_verify: ushouldverify,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            txtindividualPanCount.value = 1;
            btnindividualPan.disabled = true;
            btnindividualPan.style.background = "#2faa4a";
            btnindividualPan.innerText = "UPLOADED";
            this.setState({ submit: true });
            // const details = JSON.parse(result.payLoad)
            // document.getElementById('individualPanName').value = details.name
            // document.getElementById('individualPanFName').value = details.fathers_name
            // document.getElementById('individualPanNo').value = details.id_no
            // document.getElementById('individualPanDOB').value = details.dob
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  individualUdyogAadhaar = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var udocument = document.getElementById(
      "lblindividualUdyogAadhaarFileFront"
    );
    var uidno = document.getElementById("txtaadharno-modal").value;
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Individual";
    var udocumenttype = "business document";
    var furl = "data:image/png;base64 ," + udocument.innerText;
    var txtindividualUdyogAadhaarCount = document.getElementById(
      "txtindividualUdyogAadhaarCount"
    );
    var btnindividualUdyogAadhaar = document.getElementById(
      "btnindividualUdyogAadhaar"
    );

    if (udocument.innerText === "") {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    if (uidno === "") {
      this.setState({ imageUploadedError2: true });
      return false;
    } else {
      this.setState({ imageUploadedError2: false });
    }
    this.setState({ isLoaded: true, udyogErrorResponse: false });

    fetch(`${base_url}api/digioBusinessapi/UAADHAAR`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        document: furl,
        // "front_part":furl,
        // "back_part":burl,
        idNo: uidno,
        business_type: ubusinestype,
        me_id: this.state.meId,
        document_type: udocumenttype,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            txtindividualUdyogAadhaarCount.value = 1;
            btnindividualUdyogAadhaar.disabled = true;
            btnindividualUdyogAadhaar.style.background = "#2faa4a";
            btnindividualUdyogAadhaar.innerText = "UPLOADED";
            this.setState({ submit: true });
            // const details = JSON.parse(result.payLoad)
            // document.getElementById('indUdyogAadhaarName').value = details.name
            // document.getElementById('indUdyogAadhaarCardNo').value = details.id_no
            // document.getElementById('indUdyogAadhaarAddress').value = details.address ? details.address : ''
          } else {
            this.setState({ udyogErrorResponse: true });
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };

  proprietorGst = (event) => {
    event.preventDefault();
    this.handleGSTIN();
    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var udocument = document.getElementById("lblproprietorGstFile");
    var uidno = document.getElementById("txtgstno-modal").value;
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Proprietorship";
    var udocumenttype = "business document";
    // var furl = `data:${file.type};base64 ,` + udocument.innerText;
    const furl = this.state.proprietorGstFile;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    if (uidno === "") {
      this.setState({ imageUploadedError2: true });
      return false;
    } else {
      this.setState({ imageUploadedError2: false });
    }
    this.setState({ isLoaded: true, GSTINErrorResponse: false });

    fetch(`${base_url}api/digioGstApi`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        document: furl,
        idNo: uidno,
        business_type: ubusinestype,
        me_id: this.state.meId,
        document_type: udocumenttype,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            this.proprGst();
          } else {
            this.setState({ GSTINErrorResponse: true });
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  proprietorPan = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var upan = document.getElementById("lblproprietorPanFile"); //this.state.fileFront;
    var ubackpart = "blank";
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Proprietorship"; //localStorage.getItem('cat');
    var udocumenttype = "business document";
    var udocumenttypename = "Company Pan Card";
    // var furl = `data:${file.type};base64 ,` + upan.innerText;
    const furl = this.state.proprietorPanFile;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    this.setState({ isLoaded: true });

    fetch(`${base_url}api/digio/documentUpload`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        front_part: furl,
        back_part: ubackpart,
        unique_request_id: uuniquerequestid,
        should_verify: ushouldverify,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            this.propCompanyPan();
            // const details = JSON.parse(result.payLoad)
            // document.getElementById('proprietorPanName').value = details.name
            // document.getElementById('proprietorPanFName').value = details.fathers_name
            // document.getElementById('proprietorPanNo').value = details.id_no
            // document.getElementById('proprietorPanDOB').value = details.dob
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  proprietorUdyogAadhaar = (event) => {
    event.preventDefault();
    this.handleUdyogAadhar();
    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var udocument = document.getElementById(
      "lblproprietorUdyogAadhaarFileFront"
    );
    var uidno = document.getElementById("txtaadharno-modal").value;
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Proprietorship";
    var udocumenttype = "business document";
    // var furl = `data:${file.type};base64 ,` + udocument.innerText;
    const furl = this.state.proprietorUdyogAadhaarFileFront;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    if (uidno === "") {
      this.setState({ imageUploadedError2: true });
      return false;
    } else {
      this.setState({ imageUploadedError2: false });
    }
    this.setState({ isLoaded: true, udyogErrorResponse: false });

    fetch(`${base_url}api/digioBusinessapi/UAADHAAR`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        document: furl,
        idNo: uidno,
        business_type: ubusinestype,
        me_id: this.state.meId,
        document_type: udocumenttype,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            this.propUAadhaar();
            // const details = JSON.parse(result.payLoad)
            // document.getElementById('propUdyogAadhaarName').value = details.name
            // document.getElementById('propUdyogAadhaarNo').value = details.id_no
            // document.getElementById('propUdyogAadhaarAddress').value = details.address ? details.address : ''
          } else {
            this.setState({ udyogErrorResponse: true });
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };

  proprietorFood = (event) => {
    event.preventDefault();
    this.handleFSSAI();
    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var udocument = document.getElementById("lblproprietorFoodFile");
    var uidno = document.getElementById("txtfoodno-modal").value;
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Proprietorship";
    var udocumenttype = "business document";
    // var furl = `data:${file.type};base64 ,` + udocument.innerText;
    const furl = this.state.proprietorFoodFile;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    if (uidno === "") {
      this.setState({ imageUploadedError2: true });
      return false;
    } else {
      this.setState({ imageUploadedError2: false });
    }
    this.setState({ isLoaded: true, foodErrorResponse: false });

    fetch(`${base_url}api/digioBusinessapi/digioGstApi`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        document: furl,
        idNo: uidno,
        business_type: ubusinestype,
        me_id: this.state.meId,
        document_type: udocumenttype,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            this.propFood();
          } else {
            this.setState({ foodErrorResponse: true });
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  partnerGst = (event) => {
    event.preventDefault();
    this.handleGSTIN();
    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var udocument = document.getElementById("lblpartnerGstFile");
    var uidno = document.getElementById("txtgstno-modal").value;
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Partnership/LLP";
    var udocumenttype = "business document";
    // var furl = `data:${file.type};base64 ,` + udocument.innerText;
    const furl = this.state.partnerGstFile;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    if (uidno === "") {
      this.setState({ imageUploadedError2: true });
      return false;
    } else {
      this.setState({ imageUploadedError2: false });
    }
    this.setState({ isLoaded: true, GSTINErrorResponse: false });

    fetch(`${base_url}api/digioGstApi`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        document: furl,
        idNo: uidno,
        business_type: ubusinestype,
        me_id: this.state.meId,
        document_type: udocumenttype,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            this.partnerIniGst();
          } else {
            this.setState({ GSTINErrorResponse: true });
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  partnerPan = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var upan = document.getElementById("lblpartnerPanFile"); //this.state.fileFront;
    var ubackpart = "blank";
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Partnership/LLP"; //localStorage.getItem('cat');
    var udocumenttype = "business document";
    var udocumenttypename = "Company Pan Card";
    // var furl = `data:${file.type};base64 ,` + upan.innerText;
    const furl = this.state.partnerPanFile;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    this.setState({ isLoaded: true });

    fetch(`${base_url}api/digio/documentUpload`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        front_part: furl,
        back_part: ubackpart,
        unique_request_id: uuniquerequestid,
        should_verify: ushouldverify,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            this.partnerCompanyPan();
            // const details = JSON.parse(result.payLoad)
            // document.getElementById('partnerPanName').value = details.name
            // document.getElementById('partnerPanFName').value = details.fathers_name
            // document.getElementById('partnerPanNo').value = details.id_no
            // document.getElementById('partnerPanDOB').value = details.dob
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  partnerDeed = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var ufrontpart = document.getElementById("lblpartnerDeedFile");

    var ubackpart = "blank";
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Partnership/LLP"; //localStorage.getItem('cat');
    var udocumenttype = "business document";
    var udocumenttypename = "Paternership Deed";
    // var furl = `data:${file.type};base64 ,` + ufrontpart.innerText;
    const furl = this.state.partnerDeedFile;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    this.setState({ isLoaded: true });

    fetch(`${base_url}api/uploadDocuments`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        document: furl,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            this.partDeed();
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  partnerCIN = (event) => {
    event.preventDefault();
    this.handleCIN();
    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var udocument = document.getElementById("lblpartnerCINFileFront");
    var uidno = document.getElementById("txtcinno-modal").value;
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Partnership/LLP";
    var udocumenttype = "business document";
    // var furl = `data:${file.type};base64 ,` + udocument.innerText;
    const furl = this.state.partnerCINFileFront;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    if (uidno === "") {
      this.setState({ imageUploadedError2: true });
      return false;
    } else {
      this.setState({ imageUploadedError2: false });
    }
    this.setState({ isLoaded: true, CINErrorResponse: false });

    fetch(`${base_url}api/digioBusinessapi/CIN`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        document: furl,
        idNo: uidno,
        business_type: ubusinestype,
        me_id: this.state.meId,
        document_type: udocumenttype,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            this.partCIN();
          } else {
            this.setState({ CINErrorResponse: true });
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  partnerFood = (event) => {
    event.preventDefault();
    this.handleFSSAI();
    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var udocument = document.getElementById("lblpartnerFoodFile");
    var uidno = document.getElementById("txtfoodno-modal").value;
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Partnership/LLP";
    var udocumenttype = "business document";
    // var furl = `data:${file.type};base64 ,` + udocument.innerText;
    const furl = this.state.partnerFoodFile;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    if (uidno === "") {
      this.setState({ imageUploadedError2: true });
      return false;
    } else {
      this.setState({ imageUploadedError2: false });
    }
    this.setState({ isLoaded: true, foodErrorResponse: false });

    fetch(`${base_url}api/digioBusinessapi/FSSAI`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        document: furl,
        idNo: uidno,
        business_type: ubusinestype,
        me_id: this.state.meId,
        document_type: udocumenttype,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            this.partFood();
          } else {
            this.setState({ foodErrorResponse: true });
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  publicGst = (event) => {
    event.preventDefault();
    this.handleGSTIN();
    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var udocument = document.getElementById("lblpublicGstFile");
    var uidno = document.getElementById("txtgstno-modal").value;
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "PrivateLtd./PublicLtd.";
    var udocumenttype = "business document";
    // var furl = `data:${file.type};base64 ,` + udocument.innerText;
    const furl = this.state.publicGstFile;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    if (uidno === "") {
      this.setState({ imageUploadedError2: true });
      return false;
    } else {
      this.setState({ imageUploadedError2: false });
    }
    this.setState({ isLoaded: true, GSTINErrorResponse: false });

    fetch(`${base_url}api/digioGstApi`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        document: furl,
        idNo: uidno,
        business_type: ubusinestype,
        me_id: this.state.meId,
        document_type: udocumenttype,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            this.publicIniGst();
          } else {
            this.setState({ GSTINErrorResponse: true });
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  publicPan = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var upan = document.getElementById("lblpublicPanFile"); //this.state.fileFront;
    var ubackpart = "blank";
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "PrivateLtd./PublicLtd."; //localStorage.getItem('cat');
    var udocumenttype = "business document";
    var udocumenttypename = "Company Pan Card";
    // var furl = `data:${file.type};base64 ,` + upan.innerText;
    const furl = this.state.publicPanFile;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    this.setState({ isLoaded: true });

    fetch(`${base_url}api/digio/documentUpload`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        front_part: furl,
        back_part: "blank",
        unique_request_id: uuniquerequestid,
        should_verify: ushouldverify,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            this.publicIniCompanyPan();
            // const details = JSON.parse(result.payLoad)
            // document.getElementById('publicPanName').value = details.name
            // document.getElementById('publicPanFName').value = details.fathers_name
            // document.getElementById('publicPanNo').value = details.id_no
            // document.getElementById('publicPanDOB').value = details.dob
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  publicBR = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var ufrontpart = document.getElementById("lblpublicBRFile");
    var ubackpart = "blank";
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "PrivateLtd./PublicLtd."; //localStorage.getItem('cat');
    var udocumenttype = "business document";
    var udocumenttypename = "Board Resolution";
    // var furl = `data:${file.type};base64 ,` + ufrontpart.innerText;
    const furl = this.state.publicBRFile;

    // console.log("document=>", furl);

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    this.setState({ isLoaded: true });

    fetch(`${base_url}api/uploadDocuments`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        document: furl,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            this.publicIniBoard();
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  publicCIN = (event) => {
    event.preventDefault();
    this.handleCIN();
    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var udocument = document.getElementById("lblpublicCINFileFront");
    var uidno = document.getElementById("txtcinno-modal").value;
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "PrivateLtd./PublicLtd.";
    var udocumenttype = "business document";
    // var furl = `data:${file.type};base64 ,` + udocument.innerText;
    const furl = this.state.publicCINFileFront;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    if (uidno === "") {
      this.setState({ imageUploadedError2: true });
      return false;
    } else {
      this.setState({ imageUploadedError2: false });
    }
    this.setState({ isLoaded: true, CINErrorResponse: false });

    fetch(`${base_url}api/digioBusinessapi/CIN`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        document: furl,
        idNo: uidno,
        business_type: ubusinestype,
        me_id: this.state.meId,
        document_type: udocumenttype,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            this.publicIniCin();
          } else {
            this.setState({ CINErrorResponse: true });
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  publicDIN = (event) => {
    event.preventDefault();
    this.handleDIN();
    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var udocument = document.getElementById("lblpublicDINFileFront");
    var uidno = document.getElementById("txtdinno-modal").value;
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "PrivateLtd./PublicLtd.";
    var udocumenttype = "business document";
    var udocumenttypename = "DIN";
    // var furl = `data:${file.type};base64 ,` + udocument.innerText;
    const furl = this.state.publicDINFileFront;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    if (uidno === "") {
      this.setState({ imageUploadedError2: true });
      return false;
    } else {
      this.setState({ imageUploadedError2: false });
    }
    this.setState({ isLoaded: true, DINErrorResponse: false });

    fetch(`${base_url}api/digioBusinessapi/DIN`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        document: furl,
        idNo: uidno,
        business_type: ubusinestype,
        me_id: this.state.meId,
        document_type: udocumenttype,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            this.publicIniDin();
          } else {
            this.setState({ DINErrorResponse: true });
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  publicMOA = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var ufrontpart = document.getElementById("lblpublicMOAFile");
    var ubackpart = "";
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "PrivateLtd./PublicLtd."; //localStorage.getItem('cat');
    var udocumenttype = "business document";
    var udocumenttypename = "Memorandum of Association";
    // var furl = `data:${file.type};base64 ,` + ufrontpart.innerText;
    const furl = this.state.publicMOAFile;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    this.setState({ isLoaded: true });

    fetch(`${base_url}api/uploadDocuments`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        document: furl,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            this.publicIniMemo();
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  publicAOA = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var ufrontpart = document.getElementById("lblpublicAOAFile");
    var ubackpart = "blank";
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "PrivateLtd./PublicLtd."; //localStorage.getItem('cat');
    var udocumenttype = "business document";
    var udocumenttypename = "Article of Associations";
    // var furl = `data:${file.type};base64 ,` + ufrontpart.innerText;
    const furl = this.state.publicAOAFile;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    this.setState({ isLoaded: true });

    fetch(`${base_url}api/uploadDocuments`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        document: furl,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            this.publicIniArt();
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  publicUdyogAadhaar = (event) => {
    event.preventDefault();
    this.handleUdyogAadhar();
    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var udocument = document.getElementById("lblpublicUdyogAadhaarFileFront");
    var uidno = document.getElementById("txtaadharno-modal").value;
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "PrivateLtd./PublicLtd.";
    var udocumenttype = "business document";
    var udocumenttypename = "Udyog Aadhaar";
    // var furl = `data:${file.type};base64 ,` + udocument.innerText;
    const furl = this.state.publicUdyogAadhaarFileFront;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    if (uidno === "") {
      this.setState({ imageUploadedError2: true });
      return false;
    } else {
      this.setState({ imageUploadedError2: false });
    }
    this.setState({ isLoaded: true, udyogErrorResponse: false });

    fetch(`${base_url}api/digioBusinessapi/UAADHAAR`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        document: furl,
        idNo: uidno,
        business_type: ubusinestype,
        me_id: this.state.meId,
        document_type: udocumenttype,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            this.publicIniUAadhaar();
            // const details = JSON.parse(result.payLoad)
            // document.getElementById('publicUdyogAadhaarName').value = details.name
            // document.getElementById('publicUdyogAadhaarNo').value = details.id_no
            // document.getElementById('publicUdyogAadhaarAddress').value = details.address ? details.address : ''
          } else {
            this.setState({ udyogErrorResponse: true });
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  publicFood = (event) => {
    event.preventDefault();
    this.handleFSSAI();
    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var udocument = document.getElementById("lblpublicFoodFile");
    var uidno = document.getElementById("txtfoodno-modal").value;
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "PrivateLtd./PublicLtd.";
    var udocumenttype = "business document";
    // var furl = `data:${file.type};base64 ,` + udocument.innerText;
    const furl = this.state.publicFoodFile;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    if (uidno === "") {
      this.setState({ imageUploadedError2: true });
      return false;
    } else {
      this.setState({ imageUploadedError2: false });
    }
    this.setState({ isLoaded: true, foodErrorResponse: false });

    fetch(`${base_url}api/digioBusinessapi/FSSAI`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        document: furl,
        idNo: uidno,
        business_type: ubusinestype,
        me_id: this.state.meId,
        document_type: udocumenttype,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            this.publicIniFood();
          } else {
            this.setState({ foodErrorResponse: true });
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  socialGst = (event) => {
    event.preventDefault();
    this.handleGSTIN();
    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var udocument = document.getElementById("lblsocialGstFile");
    var uidno = document.getElementById("txtgstno-modal").value;
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Trust/Society";
    var udocumenttype = "business document";
    // var furl = `data:${file.type};base64 ,` + udocument.innerText;
    const furl = this.state.socialGstFile;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    if (uidno === "") {
      this.setState({ imageUploadedError2: true });
      return false;
    } else {
      this.setState({ imageUploadedError2: false });
    }
    this.setState({ isLoaded: true, GSTINErrorResponse: false });

    fetch(`${base_url}api/digioGstApi`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        document: furl,
        idNo: uidno,
        business_type: ubusinestype,
        me_id: this.state.meId,
        document_type: udocumenttype,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            this.societyGst();
          } else {
            this.setState({ GSTINErrorResponse: true });
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  socialPan = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var upan = document.getElementById("lblsocialPanFile"); //this.state.fileFront;
    var ubackpart = "blank";
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Trust/Society"; //localStorage.getItem('cat');
    var udocumenttype = "business document";
    var udocumenttypename = "Company Pan Card";
    // var furl = `data:${file.type};base64 ,` + upan.innerText;
    const furl = this.state.socialPanFile;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    this.setState({ isLoaded: true });

    fetch(`${base_url}api/digio/documentUpload`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        front_part: furl,
        back_part: "blank",
        unique_request_id: uuniquerequestid,
        should_verify: ushouldverify,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            this.societyCompanyPan();
            // const details = JSON.parse(result.payLoad)
            // document.getElementById('socialPanName').value = details.name
            // document.getElementById('socialPanFName').value = details.fathers_name
            // document.getElementById('socialPanNo').value = details.id_no
            // document.getElementById('socialPanDOB').value = details.dob
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  socialTAC = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var ufrontpart = document.getElementById("lblsocialTACFile");
    var ubackpart = "blank";
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Trust/Society"; //localStorage.getItem('cat');
    var udocumenttype = "business document";
    var udocumenttypename = "Trust Act Certificate";
    // var furl = `data:${file.type};base64 ,` + ufrontpart.innerText;
    const furl = this.state.socialTACFile;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    this.setState({ isLoaded: true });

    fetch(`${base_url}api/uploadDocuments`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        document: furl,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            this.societyTrust();
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  socialBR = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var ufrontpart = document.getElementById("lblsocialBRFile");
    var ubackpart = "blank";
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Trust/Society"; //localStorage.getItem('cat');
    var udocumenttype = "business document";
    var udocumenttypename = "Authorization Letter Or Board Resolution";
    // var furl = `data:${file.type};base64 ,` + ufrontpart.innerText;
    const furl = this.state.socialBRFile;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    this.setState({ isLoaded: true });

    fetch(`${base_url}api/uploadDocuments`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        document: furl,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            this.societyAuth();
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  socialDeed = (event) => {
    event.preventDefault();

    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var ufrontpart = document.getElementById("lblsocialDeedFile");
    var ubackpart = "blank";
    var uuniquerequestid = ""; // localStorage.getItem('uuniquerequestid');
    var ushouldverify = "No";
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Trust/Society"; //localStorage.getItem('cat');
    var udocumenttype = "business document";
    var udocumenttypename = "Trust Deed";
    // var furl = `data:${file.type};base64 ,` + ufrontpart.innerText;
    const furl = this.state.socialDeedFile;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    this.setState({ isLoaded: true });

    fetch(`${base_url}api/uploadDocuments`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        document: furl,
        me_id: this.state.meId,
        business_type: ubusinestype,
        document_type: udocumenttype,
        document_type_name: udocumenttypename,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ submit: true });
            this.societyDeed();
          } else {
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };
  socialFood = (event) => {
    event.preventDefault();
    this.handleFSSAI();
    const ClientId = Buffer.from(client_Id).toString("base64");
    const ClientSecret = Buffer.from(client_Secret).toString("base64");
    var udocument = document.getElementById("lblsocialFoodFile");
    var uidno = document.getElementById("txtfoodno-modal").value;
    // var umeid = localStorage.getItem("umeid");
    var ubusinestype = "Trust/Society";
    var udocumenttype = "business document";
    var udocumenttypename = "FSSAI Certificate";
    // var furl = `data:${file.type};base64 ,` + udocument.innerText;
    const furl = this.state.socialFoodFile;

    if (!furl) {
      this.setState({ imageUploadedError1: true });
      return false;
    } else {
      this.setState({ imageUploadedError1: false });
    }
    if (uidno === "") {
      this.setState({ imageUploadedError2: true });
      return false;
    } else {
      this.setState({ imageUploadedError2: false });
    }
    this.setState({ isLoaded: true, foodErrorResponse: false });

    fetch(`${base_url}api/digioBusinessapi/FSSAI`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Authorization: "Basic " + ClientId,
        Accept: "application/json",
        "Content-Type": "application/json",
        //auth: this.state.authToken,
      },
      body: JSON.stringify({
        document: furl,
        business_type: ubusinestype,
        me_id: this.state.meId,
        idNo: uidno,
        document_type: udocumenttype,
        document_type_name: udocumenttypename,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });

          if (result.statusCode == "200") {
            this.setState({ submit: true });
            this.societyFood();
          } else {
            this.setState({ foodErrorResponse: true });
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          //alert('Failed');
        }
      );
  };

  checkGst = (gstCount) => {
    let gstStatus;
    if (this.state.isGstAvailable === "yes") {
      if (gstCount === 1) {
        gstStatus = true;
      } else {
        gstStatus = false;
      }
    } else {
      gstStatus = true;
    }
    return gstStatus;
  };

  checkNthank = () => {
    var txtindividualGstCount = document.getElementById(
      "txtindividualGstCount"
    );
    var btnindividualGst = document.getElementById("btnindividualGst");
    var txtindividualPanCount = document.getElementById(
      "txtindividualPanCount"
    );
    var btnindividualPan = document.getElementById("btnindividualPan");
    var txtindividualUdyogAadhaarCount = document.getElementById(
      "txtindividualUdyogAadhaarCount"
    );
    var btnindividualUdyogAadhaar = document.getElementById(
      "btnindividualUdyogAadhaar"
    );
    var txtindividualFoodCount = document.getElementById(
      "txtindividualFoodCount"
    );
    var txtproprietorGstCount = document.getElementById(
      "txtproprietorGstCount"
    );
    var btnproprietorGst = document.getElementById("btnproprietorGst");
    var txtproprietorPanCount = document.getElementById(
      "txtproprietorPanCount"
    );
    var btnproprietorPan = document.getElementById("btnproprietorPan");
    var txtproprietorUdyogAadhaarCount = document.getElementById(
      "txtproprietorUdyogAadhaarCount"
    );
    var btnproprietorUdyogAadhaar = document.getElementById(
      "btnproprietorUdyogAadhaar"
    );
    var txtproprietorFoodCount = document.getElementById(
      "txtproprietorFoodCount"
    );
    var txtpartnerGstCount = document.getElementById("txtpartnerGstCount");
    var btnpartnerGst = document.getElementById("btnpartnerGst");
    var txtpartnerPanCount = document.getElementById("txtpartnerPanCount");
    var btnpartnerPan = document.getElementById("btnpartnerPan");
    var txtpartnerDeedCount = document.getElementById("txtpartnerDeedCount");
    var btnpartnerDeed = document.getElementById("btnpartnerDeed");
    var txtpartnerCINCount = document.getElementById("txtpartnerCINCount");
    var btnpartnerCIN = document.getElementById("btnpartnerCIN");
    var txtpartnerFoodCount = document.getElementById("txtpartnerFoodCount");
    var txtpublicGstCount = document.getElementById("txtpublicGstCount");
    var btnpublicGst = document.getElementById("btnpublicGst");
    var txtpublicPanCount = document.getElementById("txtpublicPanCount");
    var btnpublicPan = document.getElementById("btnpublicPan");
    var txtpublicBRCount = document.getElementById("txtpublicBRCount");
    var btnpublicBR = document.getElementById("btnpublicBR");
    var txtpublicCINCount = document.getElementById("txtpublicCINCount");
    var btnpublicCIN = document.getElementById("btnpublicCIN");
    var txtpublicDINCount = document.getElementById("txtpublicDINCount");
    var btnpublicDIN = document.getElementById("btnpublicDIN");
    var txtpublicMOACount = document.getElementById("txtpublicMOACount");
    var btnpublicMOA = document.getElementById("btnpublicMOA");
    var txtpublicAOACount = document.getElementById("txtpublicAOACount");
    var btnpublicAOA = document.getElementById("btnpublicAOA");
    var txtpublicUdyogAadhaarCount = document.getElementById(
      "txtpublicUdyogAadhaarCount"
    );
    var btnpublicUdyogAadhaar = document.getElementById(
      "btnpublicUdyogAadhaar"
    );
    var txtpublicFoodCount = document.getElementById("txtpublicFoodCount");
    var txtsocialGstCount = document.getElementById("txtsocialGstCount");
    var btnsocialGst = document.getElementById("btnsocialGst");
    var txtsocialPanCount = document.getElementById("txtsocialPanCount");
    var btnsocialPan = document.getElementById("btnsocialPan");
    var txtsocialTACCount = document.getElementById("txtsocialTACCount");
    var btnsocialTAC = document.getElementById("btnsocialTAC");
    var txtsocialBRCount = document.getElementById("txtsocialBRCount");
    var btnsocialBR = document.getElementById("btnsocialBR");
    var txtsocialDeedCount = document.getElementById("txtsocialDeedCount");
    var btnsocialDeed = document.getElementById("btnsocialDeed");
    var txtsocialFoodCount = document.getElementById("txtsocialFoodCount");

    // var btype = localStorage.getItem("btype");

    if (this.state.btype == "Individual") {
      if (
        this.checkGst(parseInt(txtindividualGstCount.value)) &&
        parseInt(txtindividualPanCount.value) === 1
        // && parseInt(txtindividualUdyogAadhaarCount.value) === 1
      ) {
        if (this.state.foodCat === "Food") {
          if (parseInt(txtindividualFoodCount) === 1) {
            window.location.href = "/agreementdoc";
          }
        } else {
          window.location.href = "/agreementdoc";
        }
      }
    } else if (this.state.btype == "Proprietorship") {
      if (
        this.checkGst(parseInt(txtproprietorGstCount.value)) &&
        parseInt(txtproprietorPanCount.value) === 1
        // parseInt(txtproprietorUdyogAadhaarCount.value) === 1
      ) {
        if (this.state.foodCat === "Food") {
          if (parseInt(txtproprietorFoodCount) === 1) {
            window.location.href = "/agreementdoc";
          }
        } else {
          window.location.href = "/agreementdoc";
        }
      } else {
        this.setState({ fileUploadError: true });
      }
    } else if (this.state.btype == "Partnership/LLP") {
      if (
        this.checkGst(parseInt(txtpartnerGstCount.value)) &&
        parseInt(txtpartnerPanCount.value) === 1 &&
        parseInt(txtpartnerDeedCount.value) === 1 &&
        parseInt(txtpartnerCINCount.value) === 1
      ) {
        if (this.state.foodCat === "Food") {
          if (parseInt(txtpartnerFoodCount) === 1) {
            window.location.href = "/agreementdoc";
          }
        } else {
          window.location.href = "/agreementdoc";
        }
      } else {
        this.setState({ fileUploadError: true });
      }
    } else if (this.state.btype == "PrivateLtd./PublicLtd.") {
      if (
        this.checkGst(parseInt(txtpublicGstCount.value)) &&
        parseInt(txtpublicPanCount.value) === 1 &&
        parseInt(txtpublicBRCount.value) === 1 &&
        parseInt(txtpublicCINCount.value) === 1 &&
        parseInt(txtpublicDINCount.value) === 1 &&
        parseInt(txtpublicMOACount.value) === 1 &&
        parseInt(txtpublicAOACount.value) === 1
        // && parseInt(txtpublicUdyogAadhaarCount.value) === 1
      ) {
        if (this.state.foodCat === "Food") {
          if (parseInt(txtpublicFoodCount) === 1) {
            window.location.href = "/agreementdoc";
          }
        } else {
          window.location.href = "/agreementdoc";
        }
      } else {
        this.setState({ fileUploadError: true });
      }
    } else if (this.state.btype == "Trust/Society") {
      if (
        this.checkGst(parseInt(txtsocialGstCount.value)) &&
        parseInt(txtsocialPanCount.value) === 1 &&
        parseInt(txtsocialTACCount.value) === 1 &&
        parseInt(txtsocialBRCount.value) === 1 &&
        parseInt(txtsocialDeedCount.value) === 1
      ) {
        if (this.state.foodCat === "Food") {
          if (parseInt(txtsocialFoodCount) === 1) {
            window.location.href = "/agreementdoc";
          }
        } else {
          window.location.href = "/agreementdoc";
        }
      } else {
        this.setState({ fileUploadError: true });
      }
    }
  };
  handleCIN = () => {
    const cin = document.getElementById("txtcinno-modal").value;
    if (!CINValidation(cin)) {
      this.setState({ cinError: true });
      document.getElementById("txtcinno-modal").classList.add("is-invalid");
      return false;
    } else {
      this.setState({ cinError: false });
      document.getElementById("txtcinno-modal").classList.remove("is-invalid");
    }
  };
  handleDIN = () => {
    const din = document.getElementById("txtdinno-modal").value;
    if (!DINValidation(din)) {
      this.setState({ dinError: true });
      document.getElementById("txtdinno-modal").classList.add("is-invalid");
      return false;
    } else {
      this.setState({ dinError: false });
      document.getElementById("txtdinno-modal").classList.remove("is-invalid");
    }
  };

  handleUdyogAadhar = () => {
    const udyog = document.getElementById("txtaadharno-modal").value;
    if (!UaadharValidation(udyog)) {
      this.setState({ udhaarError: true });
      document.getElementById("txtaadharno-modal").classList.add("is-invalid");
      return false;
    } else {
      this.setState({ udhaarError: false });
      document
        .getElementById("txtaadharno-modal")
        .classList.remove("is-invalid");
    }
  };
  handleFSSAI = () => {
    const fssai = document.getElementById("txtfoodno-modal").value;
    if (!FSSAIValidation(fssai)) {
      this.setState({ fssaiError: true });
      document.getElementById("txtfoodno-modal").classList.add("is-invalid");
      return false;
    } else {
      this.setState({ fssaiError: false });
      document.getElementById("txtfoodno-modal").classList.remove("is-invalid");
    }
  };
  handleGSTIN = () => {
    const gstin = document.getElementById("txtgstno-modal").value;
    if (!GSTINValidation(gstin)) {
      this.setState({ gstError: true });
      document.getElementById("txtgstno-modal").classList.add("is-invalid");
      return false;
    } else {
      this.setState({ gstError: false });
      document.getElementById("txtgstno-modal").classList.remove("is-invalid");
    }
  };
  render() {
    return (
      <>
        <section className="dv-Registration-content doc-main-div">
          <div className="first-bg htg"></div>
          <div className="container">
            <div className="row">
              <div
                className="col-md-6 dv-instruction"
                data-aos="fade-right"
                data-aos-duration="1000"
              >
                <h1 className="section-heading">
                  Quick &amp; Easy Activation Process
                </h1>
                <div className="row">
                  <div className="col-md-4 pr-0">
                    <div className="dv-step completed">
                      <div className="step">Step 1</div>
                      <div className="text">
                        Check email for Username &amp; OTP.
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 pr-0">
                    <div className="dv-step completed">
                      <div className="step">Step 2</div>
                      <div className="text">
                        Enter Username &amp; OTP. <br />
                        Set a desirable password.
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 pr-0">
                    <div className="dv-step">
                      <div className="step">Step 3</div>
                      <div className="text">
                        Fill in all the details &amp; upload documents to start
                        activation process.
                      </div>
                    </div>
                  </div>
                </div>
                <ul className="tick mt-3 mr-5">
                  <li className="completed">
                    Business Overview <span className="hr-white"></span>{" "}
                  </li>
                  {/* <li className="completed">Business Contact Details <span className="hr-white"></span></li> */}
                  <li className="completed">
                    Bank Account Details <span className="hr-white"></span>
                  </li>
                  <li>Agreement &amp; KYC Documents</li>
                </ul>
              </div>
              <div
                className="col-md-6 form-div"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <div className="dv-login-form dv-form">
                  <h1 className="section-heading border-heading no-border-heading">
                    {this.props.name}
                  </h1>
                  <div className="dv-indicator">
                    <ul className="indicator">
                      <li className="box completed"></li>
                      <li className="line"></li>
                      <li className="box"></li>
                      <li className="line"></li>
                      <li className="box"></li>
                    </ul>
                  </div>
                  <h4 className="text-center doc-txt">Business Documents</h4>

                  <div className="dv-doc dv-ind db-block">
                    <div className="dv-particular">
                      <label className="lbl">GST Certificate</label>
                      <span className="note">
                        GST registration compulsory above 40 lakhs
                      </span>
                      <div className="flex-ul">
                        <span className="note flex-ul">
                          <input
                            type="radio"
                            value="yes"
                            id="gst-yes"
                            checked={this.state.isGstAvailable === "yes"}
                            onChange={(e) =>
                              this.setState({ isGstAvailable: e.target.value })
                            }
                          />
                          <label htmlFor="gst-yes">Yes</label>
                        </span>
                        <span className="note flex-ul">
                          <input
                            type="radio"
                            value="no"
                            id="gst-no"
                            checked={this.state.isGstAvailable === "no"}
                            onChange={(e) =>
                              this.setState({ isGstAvailable: e.target.value })
                            }
                          />
                          <label htmlFor="gst-no">No</label>
                        </span>
                      </div>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtindividualGstCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnindividualGst"
                        onClick={() => this.toggleModal("individualGstModal")}
                        disabled={this.state.isGstAvailable === "no"}
                      >
                        UPLOAD
                      </button>
                    </div>
                    <div className="clearfix"></div>
                    {/* <div className="custom-control custom-radio custom-control-inline my-1">
                                            <input type="radio" id="txtgstno1" name="txtgstno" className="custom-control-input" defaultChecked />
                                            <label className="custom-control-label" htmlFor="txtgstno1">Yes</label>
                                        </div>
                                        <div className="custom-control custom-radio custom-control-inline">
                                            <input type="radio" id="txtgstno2" name="txtgstno" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="txtgstno2">No</label>
                                        </div>
                                        <input type="text" className="form-control" id="txtgstno" placeholder="Enter GSTIN number" /> */}
                  </div>

                  <div className="dv-doc dv-ind">
                    <div className="dv-particular">
                      <label className="lbl">
                        Company Pancard<span className="red">*</span>
                      </label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtindividualPanCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnindividualPan"
                        onClick={() => this.toggleModal("individualPanModal")}
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>

                  <div className="dv-doc dv-ind">
                    <div className="dv-particular">
                      <label className="lbl">Udyog Aadhaar</label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtindividualUdyogAadhaarCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnindividualUdyogAadhaar"
                        onClick={() =>
                          this.toggleModal("individualUdyogAadhaar")
                        }
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  {this.state.foodCat === "Food" && (
                    <div className="dv-doc dv-ind">
                      <div className="dv-particular">
                        <label className="lbl">
                          FSSAI Certificate<span className="red">*</span>
                        </label>
                      </div>
                      <div className="dv-field">
                        <input
                          type="text"
                          className="d-none"
                          id="txtindividualFoodCount"
                        />
                        <button
                          className="btn btn-lightblue"
                          id="btnindividualFood"
                          onClick={() =>
                            this.toggleModal("individualFoodModal")
                          }
                        >
                          UPLOAD
                        </button>
                      </div>
                    </div>
                  )}

                  {/* <div className="dv-doc dv-ind">
                                        <div className="dv-particular">
                                            <label className="lbl">Cancelled cheque </label>
                                            <span className="note">Uplaod the cheque of the registed bank</span>
                                        </div>
                                        <div className="dv-field">
                                            <button className="btn btn-green">VERIFIED</button>
                                        </div>
                                    </div> */}

                  {/* <div className="dv-doc dv-prop">
                                        <div className="dv-particular">
                                            <label className="lbl">Cancelled cheque </label>
                                            <span className="note">Uplaod the cheque of the registed bank</span>
                                        </div>
                                        <div className="dv-field">
                                            <button className="btn btn-lightblue">UPLOAD</button>
                                        </div>
                                    </div> */}
                  <div className="dv-doc dv-prop db-block">
                    <div className="dv-particular">
                      <label className="lbl">GST Certificate</label>
                      <span className="note">
                        GST registration compulsory above 40 lakhs
                      </span>
                      <div className="flex-ul">
                        <span className="note flex-ul">
                          <input
                            type="radio"
                            value="yes"
                            id="gst-yes"
                            checked={this.state.isGstAvailable === "yes"}
                            onChange={(e) =>
                              this.setState({ isGstAvailable: e.target.value })
                            }
                          />
                          <label htmlFor="gst-yes">Yes</label>
                        </span>
                        <span className="note flex-ul">
                          <input
                            type="radio"
                            value="no"
                            id="gst-no"
                            checked={this.state.isGstAvailable === "no"}
                            onChange={(e) =>
                              this.setState({ isGstAvailable: e.target.value })
                            }
                          />
                          <label htmlFor="gst-no">No</label>
                        </span>
                      </div>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtproprietorGstCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnproprietorGst"
                        onClick={() => this.toggleModal("proprietorGstModal")}
                        disabled={this.state.isGstAvailable === "no"}
                      >
                        UPLOAD
                      </button>
                    </div>
                    <div className="clearfix"></div>
                    {/* <div className="custom-control custom-radio custom-control-inline my-1">
                                            <input type="radio" id="txtgstno1" name="txtgstno" className="custom-control-input" defaultChecked />
                                            <label className="custom-control-label" htmlFor="txtgstno1">Yes</label>
                                        </div>
                                        <div className="custom-control custom-radio custom-control-inline">
                                            <input type="radio" id="txtgstno2" name="txtgstno" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="txtgstno2">No</label>
                                        </div>
                                        <input type="text" className="form-control" id="txtgstno" placeholder="Enter GSTIN number" /> */}
                  </div>

                  <div className="dv-doc dv-prop">
                    <div className="dv-particular">
                      <label className="lbl">
                        Company Pancard<span className="red">*</span>
                      </label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtproprietorPanCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnproprietorPan"
                        onClick={() => this.toggleModal("proprietorPanModal")}
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>

                  <div className="dv-doc dv-prop">
                    <div className="dv-particular">
                      <label className="lbl">Udyog Aadhaar</label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtproprietorUdyogAadhaarCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnproprietorUdyogAadhaar"
                        onClick={() =>
                          this.toggleModal("proprietorUdyogAadhaar")
                        }
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  {this.state.foodCat === "Food" && (
                    <div className="dv-doc dv-prop">
                      <div className="dv-particular">
                        <label className="lbl">
                          FSSAI Certificate<span className="red">*</span>
                        </label>
                      </div>
                      <div className="dv-field">
                        <input
                          type="text"
                          className="d-none"
                          id="txtproprietorFoodCount"
                        />
                        <button
                          className="btn btn-lightblue"
                          id="btnproprietorFood"
                          onClick={() =>
                            this.toggleModal("proprietorFoodModal")
                          }
                        >
                          UPLOAD
                        </button>
                      </div>
                    </div>
                  )}
                  {/* <div className="dv-doc dv-part">
                                        <div className="dv-particular">
                                            <label className="lbl">Cancelled Cheque </label>
                                            <span className="note">Uplaod the cheque of the registed bank</span>
                                        </div>
                                        <div className="dv-field">
                                            <button className="btn btn-lightblue">UPLOAD</button>
                                        </div>
                                    </div> */}
                  <div className="dv-doc dv-part db-block">
                    <div className="dv-particular">
                      <label className="lbl">GST Certificate</label>
                      <span className="note">
                        GST registration compulsory above 40 lakhs
                      </span>
                      <div className="flex-ul">
                        <span className="note flex-ul">
                          <input
                            type="radio"
                            value="yes"
                            id="gst-yes"
                            checked={this.state.isGstAvailable === "yes"}
                            onChange={(e) =>
                              this.setState({ isGstAvailable: e.target.value })
                            }
                          />
                          <label htmlFor="gst-yes">Yes</label>
                        </span>
                        <span className="note flex-ul">
                          <input
                            type="radio"
                            value="no"
                            id="gst-no"
                            checked={this.state.isGstAvailable === "no"}
                            onChange={(e) =>
                              this.setState({ isGstAvailable: e.target.value })
                            }
                          />
                          <label htmlFor="gst-no">No</label>
                        </span>
                      </div>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtpartnerGstCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnpartnerGst"
                        onClick={() => this.toggleModal("partnerGstModal")}
                        disabled={this.state.isGstAvailable === "no"}
                      >
                        UPLOAD
                      </button>
                    </div>
                    <div className="clearfix"></div>
                    {/* <div className="custom-control custom-radio custom-control-inline my-1">
                                            <input type="radio" id="gstno1" name="gstno" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="gstno1">Yes</label>
                                        </div>
                                        <div className="custom-control custom-radio custom-control-inline">
                                            <input type="radio" id="gstno2" name="gstno" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="gstno2">No</label>
                                        </div>
                                        <input type="text" className="form-control" id="txtgstno" placeholder="Enter GSTIN number" /> */}
                  </div>
                  <div className="dv-doc dv-part">
                    <div className="dv-particular">
                      <label className="lbl">
                        Company PAN Card<span className="red">*</span>
                      </label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtpartnerPanCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnpartnerPan"
                        onClick={() => this.toggleModal("partnerPanModal")}
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  <div className="dv-doc dv-part">
                    <div className="dv-particular">
                      <label className="lbl">
                        Paternership Deed<span className="red">*</span>
                      </label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtpartnerDeedCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnpartnerDeed"
                        onClick={() => this.toggleModal("partnerDeedModal")}
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  <div className="dv-doc dv-part">
                    <div className="dv-particular">
                      <label className="lbl">
                        Corporate Identification number (CIN)
                        <span className="red">*</span>
                      </label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtpartnerCINCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnpartnerCIN"
                        onClick={() => this.toggleModal("partnerCIN")}
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  {this.state.foodCat === "Food" && (
                    <div className="dv-doc dv-part">
                      <div className="dv-particular">
                        <label className="lbl">
                          FSSAI Certificate<span className="red">*</span>
                        </label>
                      </div>
                      <div className="dv-field">
                        <input
                          type="text"
                          className="d-none"
                          id="txtpartnerFoodCount"
                        />
                        <button
                          className="btn btn-lightblue"
                          id="btnpartnerFood"
                          onClick={() => this.toggleModal("partnerFoodModal")}
                        >
                          UPLOAD
                        </button>
                      </div>
                    </div>
                  )}

                  <div className="dv-doc dv-pub db-block">
                    <div className="dv-particular">
                      <label className="lbl">GST Certificate</label>
                      <span className="note">
                        GST registration compulsory above 40 lakhs
                      </span>
                      <div className="flex-ul">
                        <span className="note flex-ul">
                          <input
                            type="radio"
                            value="yes"
                            id="gst-yes"
                            checked={this.state.isGstAvailable === "yes"}
                            onChange={(e) =>
                              this.setState({ isGstAvailable: e.target.value })
                            }
                          />
                          <label htmlFor="gst-yes">Yes</label>
                        </span>
                        <span className="note flex-ul">
                          <input
                            type="radio"
                            value="no"
                            id="gst-no"
                            checked={this.state.isGstAvailable === "no"}
                            onChange={(e) =>
                              this.setState({ isGstAvailable: e.target.value })
                            }
                          />
                          <label htmlFor="gst-no">No</label>
                        </span>
                      </div>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtpublicGstCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnpublicGst"
                        onClick={() => this.toggleModal("publicGstModal")}
                        disabled={this.state.isGstAvailable === "no"}
                      >
                        UPLOAD
                      </button>
                    </div>
                    <div className="clearfix"></div>
                    {/* <div className="custom-control custom-radio custom-control-inline my-1">
                                            <input type="radio" id="txtgstno1" name="txtgstno" className="custom-control-input" defaultChecked />
                                            <label className="custom-control-label" htmlFor="txtgstno1">Yes</label>
                                        </div>
                                        <div className="custom-control custom-radio custom-control-inline">
                                            <input type="radio" id="txtgstno2" name="txtgstno" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="txtgstno2">No</label>
                                        </div>
                                        <input type="text" className="form-control" id="txtgstno" placeholder="Enter GSTIN number" /> */}
                  </div>
                  <div className="dv-doc dv-pub">
                    <div className="dv-particular">
                      <label className="lbl">
                        Company Pancard<span className="red">*</span>
                      </label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtpublicPanCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnpublicPan"
                        onClick={() => this.toggleModal("publicPanModal")}
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  <div className="dv-doc dv-pub">
                    <div className="dv-particular">
                      <label className="lbl">
                        Board Resolution<span className="red">*</span>
                      </label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtpublicBRCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnpublicBR"
                        onClick={() => this.toggleModal("publicBRModal")}
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  <div className="dv-doc dv-pub">
                    <div className="dv-particular">
                      <label className="lbl">
                        Corporate Identification number (CIN)
                        <span className="red">*</span>
                      </label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtpublicCINCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnpublicCIN"
                        onClick={() => this.toggleModal("publicCINModal")}
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  <div className="dv-doc dv-pub">
                    <div className="dv-particular">
                      <label className="lbl">
                        DIN<span className="red">*</span>
                      </label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtpublicDINCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnpublicDIN"
                        onClick={() => this.toggleModal("publicDINModal")}
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  <div className="dv-doc dv-pub">
                    <div className="dv-particular">
                      <label className="lbl">
                        Memorandum of Association<span className="red">*</span>
                      </label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtpublicMOACount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnpublicMOA"
                        onClick={() => this.toggleModal("publicMOAModal")}
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  <div className="dv-doc dv-pub">
                    <div className="dv-particular">
                      <label className="lbl">
                        Article of Associations<span className="red">*</span>
                      </label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtpublicAOACount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnpublicAOA"
                        onClick={() => this.toggleModal("publicAOAModal")}
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  <div className="dv-doc dv-pub">
                    <div className="dv-particular">
                      <label className="lbl">Udyog Aadhaar</label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtpublicUdyogAadhaarCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnpublicUdyogAadhaar"
                        onClick={() =>
                          this.toggleModal("publicUdyogAadhaarModal")
                        }
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  {this.state.foodCat === "Food" && (
                    <div className="dv-doc dv-pub">
                      <div className="dv-particular">
                        <label className="lbl">
                          FSSAI Certificate<span className="red">*</span>
                        </label>
                      </div>
                      <div className="dv-field">
                        <input
                          type="text"
                          className="d-none"
                          id="txtpublicFoodCount"
                        />
                        <button
                          className="btn btn-lightblue"
                          id="btnpublicFood"
                          onClick={() => this.toggleModal("publicFoodModal")}
                        >
                          UPLOAD
                        </button>
                      </div>
                    </div>
                  )}
                  <div className="dv-doc dv-soc db-block">
                    <div className="dv-particular">
                      <label className="lbl">GST Certificate</label>
                      <span className="note">
                        GST registration compulsory above 40 lakhs
                      </span>
                      <div className="flex-ul">
                        <span className="note flex-ul">
                          <input
                            type="radio"
                            value="yes"
                            id="gst-yes"
                            checked={this.state.isGstAvailable === "yes"}
                            onChange={(e) =>
                              this.setState({ isGstAvailable: e.target.value })
                            }
                          />
                          <label htmlFor="gst-yes">Yes</label>
                        </span>
                        <span className="note flex-ul">
                          <input
                            type="radio"
                            value="no"
                            id="gst-no"
                            checked={this.state.isGstAvailable === "no"}
                            onChange={(e) =>
                              this.setState({ isGstAvailable: e.target.value })
                            }
                          />
                          <label htmlFor="gst-no">No</label>
                        </span>
                      </div>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtsocialGstCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnsocialGst"
                        onClick={() => this.toggleModal("socialGstModal")}
                        disabled={this.state.isGstAvailable === "no"}
                      >
                        UPLOAD
                      </button>
                    </div>
                    <div className="clearfix"></div>
                    {/* <div className="custom-control custom-radio custom-control-inline my-1">
                                            <input type="radio" id="txtgstno1" name="txtgstno" className="custom-control-input" defaultChecked />
                                            <label className="custom-control-label" htmlFor="txtgstno1">Yes</label>
                                        </div>
                                        <div className="custom-control custom-radio custom-control-inline">
                                            <input type="radio" id="txtgstno2" name="txtgstno" className="custom-control-input" />
                                            <label className="custom-control-label" htmlFor="txtgstno2">No</label>
                                        </div>
                                        <input type="text" className="form-control" id="txtgstno" placeholder="Enter GSTIN number" /> */}
                  </div>
                  <div className="dv-doc dv-soc">
                    <div className="dv-particular">
                      <label className="lbl">
                        Company PAN Card<span className="red">*</span>
                      </label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtsocialPanCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnsocialPan"
                        onClick={() => this.toggleModal("socialPanModal")}
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  <div className="dv-doc dv-soc">
                    <div className="dv-particular">
                      <label className="lbl">
                        Trust Act Certificate<span className="red">*</span>
                      </label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtsocialTACCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnsocialTAC"
                        onClick={() => this.toggleModal("socialTACModal")}
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  <div className="dv-doc dv-soc">
                    <div className="dv-particular">
                      <label className="lbl">
                        Authorization Letter Or Board Resolution
                        <span className="red">*</span>
                      </label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtsocialBRCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnsocialBR"
                        onClick={() => this.toggleModal("socialBRModal")}
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  <div className="dv-doc dv-soc">
                    <div className="dv-particular">
                      <label className="lbl">
                        Trust Deed<span className="red">*</span>
                      </label>
                    </div>
                    <div className="dv-field">
                      <input
                        type="text"
                        className="d-none"
                        id="txtsocialDeedCount"
                      />
                      <button
                        className="btn btn-lightblue"
                        id="btnsocialDeed"
                        onClick={() => this.toggleModal("socialDeedModal")}
                      >
                        UPLOAD
                      </button>
                    </div>
                  </div>
                  {this.state.foodCat === "Food" && (
                    <div className="dv-doc dv-soc">
                      <div className="dv-particular">
                        <label className="lbl">
                          FSSAI Certificate<span className="red">*</span>
                        </label>
                      </div>
                      <div className="dv-field">
                        <input
                          type="text"
                          className="d-none"
                          id="txtsocialFoodCount"
                        />
                        <button
                          className="btn btn-lightblue"
                          id="btnsocialFood"
                          onClick={() => this.toggleModal("socialFoodModal")}
                        >
                          UPLOAD
                        </button>
                      </div>
                    </div>
                  )}
                  {/* <div className="my-5 py-5"></div> */}
                  {this.state.fileUploadError && (
                    <small className="err">
                      Please upload all required documents.
                    </small>
                  )}
                  <div className="btn-holder mt-5 text-center">
                    <a
                      className="btn btn-next btn-gradient"
                      onClick={this.checkNthank}
                    >
                      Next
                    </a>
                  </div>

                  <div className="dv-bottom-bg mt-5">
                    <div className="dv-help">
                      Need help?{" "}
                      <a href="/support" className="lnk-contact text-underline">
                        SUPPORT
                      </a>
                    </div>
                    <div className="first-bottom-bg"></div>
                    <div className="second-bottom-bg"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* individualGstModal */}
        <Modal
          className="modal-dialog-centered modal-lg individualGstModal"
          isOpen={this.state.individualGstModal}
          toggle={() => this.toggleModal("individualGstModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("individualGstModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.individualGst} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Your GST Certificate</h5>
                <p>Please upload front side</p>
              </div>
              <p className="mb-1">Enter GSTIN number</p>
              <div className="dv-GST">
                <input
                  type="text"
                  className="form-control"
                  id="txtgstno-modal"
                  placeholder="Enter GSTIN number"
                  onBlur={this.handleGSTIN}
                />

                {/* <button className="btn btn-gradient">Save</button> */}
              </div>
              {this.state.gstError && (
                <div>
                  {" "}
                  <small style={{ color: "red" }}>
                    Please enter valid GSTIN.
                  </small>
                </div>
              )}
              {this.state.GSTINErrorResponse && (
                <p className="err" style={{ textAlign: "left" }}>
                  {" "}
                  There is some technical issue or invalid GSTIN number.{" "}
                </p>
              )}
              <div className="dv-upload-img">
                {this.state.individualGstFile && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="individualGst"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.individualGstPreview}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.individualGstFile
                      ? this.state.individualGstFile
                      : uploadImg
                  }
                />
                <label id="lblindividualGstFIle" className="d-none"></label>
              </div>
              {this.state.fileSizeError1 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {this.state.imageUploadedError2 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please enter ID no.
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "individualGstModal")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        {/* individualPanModal */}
        <Modal
          className="modal-dialog-centered modal-lg uploadModalPan"
          isOpen={this.state.individualPanModal}
          toggle={() => this.toggleModal("individualPanModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("individualPanModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.individualPan} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Your Company PAN Card Copy</h5>
                <p>Please upload front side</p>
              </div>
              {/* <p className="mb-1">Enter Pan Card number</p>
                            <div className="dv-GST">
                                <input type="text" className="form-control" id="txtpanno-modal" defaultValue="" placeholder="Enter Pan Card number" />
                                
                            </div> */}
              <div className="dv-upload-img">
                {this.state.individualPanFile && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="individualPanFile"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.individualPanPreview}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.individualPanFile
                      ? this.state.individualPanFile
                      : uploadImg
                  }
                />
                <label id="lblindividualPanFile" className="d-none"></label>
              </div>
              {this.state.fileSizeError1 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              {/* <div className="filledDet">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="individualPanName">Name</label>
                                            <input type="text" className="form-control" id="individualPanName" placeholder="" disabled />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="individualPanFName">Father Name</label>
                                            <input type="text" className="form-control" id="individualPanFName" placeholder="" disabled />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="individualPanNo">PAN No.</label>
                                            <input type="text" className="form-control" id="individualPanNo" placeholder="" disabled />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="individualPanDOB">Date of Birth</label>
                                            <input type="text" className="form-control" id="individualPanDOB" placeholder="" disabled />
                                        </div>
                                    </div>
                                </div>
                            </div> */}
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "individualPanModal")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        {/* individualUdyogAadhaarModal */}
        <Modal
          className="modal-dialog-centered modal-lg individualUdyogAadhaarModal"
          isOpen={this.state.individualUdyogAadhaar}
          toggle={() => this.toggleModal("individualUdyogAadhaar")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("individualUdyogAadhaar")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.individualUdyogAadhaar} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Please upload your Udyog Aadhaar copy</h5>
                <p>Please upload front side</p>
              </div>
              <p className="mb-1">Enter Udyog Aadhar number</p>
              <div className="dv-GST">
                <input
                  type="text"
                  className="form-control"
                  id="txtaadharno-modal"
                  defaultValue=""
                  placeholder="Enter Udyog Aadhar number"
                  onBlur={this.handleUdyogAadhar}
                />

                {/* <button className="btn btn-gradient">Save</button> */}
              </div>
              {this.state.udhaarError && (
                <div>
                  {" "}
                  <small style={{ color: "red" }}>
                    Please enter valid Uaadhar.
                  </small>
                </div>
              )}
              <div className="dv-upload-img">
                {this.state.individualUdyogAadhaarFileFront && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="individualUdyogAadhaarFileFront"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.individualUdyogAadhaarPreviewFront}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.individualUdyogAadhaarFileFront
                      ? this.state.individualUdyogAadhaarFileFront
                      : uploadImg
                  }
                />
                <label
                  id="lblindividualUdyogAadhaarFileFront"
                  className="d-none"
                ></label>
              </div>
              {this.state.fileSizeError1 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              {/* <div className="row ad-upld">
                                <div className="col-md-6">
                                    <div className="dv-upload-img-small">
                                        <button className="upload-btn-small">Upload image</button>
                                        <input type="file" id="individualUdyogAadhaarFileFront" name="myfile" accept=".jpeg, .png, .jpg" onChange={this.individualUdyogAadhaarPreviewFront} />
                                        <img className="img-preview" src={this.state.individualUdyogAadhaarFileFront ? this.state.individualUdyogAadhaarFileFront : uploadImg} />
                                        <label id="lblindividualUdyogAadhaarFileFront" className="d-none"></label>
                                    </div>
                                    <p className="text-center mod-txt">Front Side</p>
                                </div>
                                    
                                
                                <div className="col-md-6">
                                    <div className="dv-upload-img-small">
                                        <button className="upload-btn-small">Upload image</button>
                                        <input type="file" id="individualUdyogAadhaarFileBack" name="myfile" accept=".jpeg, .png, .jpg" onChange={this.individualUdyogAadhaarPreviewBack} />
                                        <img className="img-preview" src={this.state.individualUdyogAadhaarFileBack ? this.state.individualUdyogAadhaarFileBack : uploadImg} />
                                        <label id="lblindividualUdyogAadhaarFileBack" className="d-none"></label>
                                    </div>
                                    <p className="text-center mod-txt">Back Side</p>
                                </div>
                            </div>
                            
                            <div className="filledDet">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="indUdyogAadhaarName">Name</label>
                                            <input type="text" className="form-control" id="indUdyogAadhaarName" placeholder="" disabled />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="indUdyogAadhaarCardNo">Aadhaar Card No.</label>
                                            <input type="text" className="form-control" id="indUdyogAadhaarCardNo" placeholder="" disabled />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="indUdyogAadhaarAddress">Address</label>
                                            <textarea className="form-control addtxtarea" name="" id="indUdyogAadhaarAddress" disabled></textarea>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group form-check m-2 px-0">
                                            <input type="checkbox" className="form-check-input cont-chk-inpt ml-0" id="chkAgreeAadhar" />
                                            <label className="form-check-label cont-chk ml-4 pl-2" htmlFor="chkAgreeAadhar">I have understood the purpose and importance of providing the aadhar details, therefore I am Voluntarily consent to provide the required details.
                                    </label>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {this.state.imageUploadedError2 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please enter ID no.
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "individualUdyogAadhaar")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        {/* Individual Food Certificate */}
        <Modal
          className="modal-dialog-centered modal-lg individualFoodModal"
          isOpen={this.state.individualFoodModal}
          toggle={() => this.toggleModal("individualFoodModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("individualFoodModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.individualFood} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Your Food Certificate</h5>
                <p>Please upload front side</p>
              </div>
              <p className="mb-1">Enter Food Certificate number</p>
              <div className="dv-GST">
                <input
                  type="text"
                  className="form-control"
                  id="txtfoodno-modal"
                  defaultValue=""
                  placeholder="Enter Food certificate number"
                  onBlur={this.handleFSSAI}
                />

                {/* <button className="btn btn-gradient">Save</button> */}
              </div>
              {this.state.fssaiError && (
                <div>
                  <small style={{ color: "red" }}>
                    Please enter valid FSSAI.
                  </small>
                </div>
              )}
              <div className="dv-upload-img">
                {this.state.individualFoodFile && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="individualFood"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.individualFoodPreview}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.individualFoodFile
                      ? this.state.individualFoodFile
                      : uploadImg
                  }
                />
                <label id="lblindividualFoodFIle" className="d-none"></label>
              </div>
              {this.state.fileSizeError1 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {this.state.imageUploadedError2 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please enter ID no.
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "individualFoodModal")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        {/* proprietorGstModal */}
        <Modal
          className="modal-dialog-centered modal-lg proprietorGstModal"
          isOpen={this.state.proprietorGstModal}
          toggle={() => this.toggleModal("proprietorGstModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("proprietorGstModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.proprietorGst} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Your GST Certificate</h5>
                <p>Please upload front side</p>
              </div>
              <p className="mb-1">Enter GSTIN number</p>
              <div className="dv-GST">
                <input
                  type="text"
                  className="form-control"
                  id="txtgstno-modal"
                  placeholder="Enter GSTIN number"
                  onBlur={this.handleGSTIN}
                />

                {/* <button className="btn btn-gradient">Save</button> */}
              </div>
              {this.state.gstError && (
                <div>
                  {" "}
                  <small style={{ color: "red" }}>
                    Please enter valid GSTIN.
                  </small>
                </div>
              )}
              {this.state.GSTINErrorResponse && (
                <p className="err" style={{ textAlign: "left" }}>
                  {" "}
                  There is some technical issue or invalid GSTIN number.{" "}
                </p>
              )}
              <div className="dv-upload-img">
                {/* <button className="upload-btn">Upload image</button> */}
                {this.state.proprietorGstFile && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="proprietorGst"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.proprietorGstPreview}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.proprietorGstFile
                      ? this.state.proprietorGstFile
                      : uploadImg
                  }
                />
                <label id="lblproprietorGstFile" className="d-none"></label>
              </div>
              {this.state.fileSizeError1 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {this.state.imageUploadedError2 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please enter ID no.
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "proprietorGstModal")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        {/* proprietorPanModal */}
        <Modal
          className="modal-dialog-centered modal-lg uploadModalPan"
          isOpen={this.state.proprietorPanModal}
          toggle={() => this.toggleModal("proprietorPanModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("proprietorPanModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.proprietorPan} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Your Company PAN Card Copy</h5>
                <p>Please upload front side</p>
              </div>
              {/* <p className="mb-1">Enter Pan Card number</p>
                            <div className="dv-GST">
                                <input type="text" className="form-control" id="txtpanno-modal" defaultValue="" placeholder="Enter Pan Card number" />
                                
                            </div> */}
              <div className="dv-upload-img">
                {this.state.proprietorPanFile && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="proprietorPanFile"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.proprietorPanPreview}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.proprietorPanFile
                      ? this.state.proprietorPanFile
                      : uploadImg
                  }
                />
                <label id="lblproprietorPanFile" className="d-none"></label>
              </div>
              {this.state.fileSizeError1 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              {/* <div className="filledDet">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="proprietorPanName">Name</label>
                                            <input type="text" className="form-control" id="proprietorPanName" placeholder="" disabled />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="proprietorPanFName">Father Name</label>
                                            <input type="text" className="form-control" id="proprietorPanFName" placeholder="" disabled />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="proprietorPanNo">PAN No.</label>
                                            <input type="text" className="form-control" id="proprietorPanNo" placeholder="" disabled />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="proprietorPanDOB">Date of Birth</label>
                                            <input type="text" className="form-control" id="proprietorPanDOB" placeholder="" disabled />
                                        </div>
                                    </div>
                                </div>
                            </div> */}
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "proprietorPanModal")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        {/* proprietorUdyogAadhaarModal */}
        <Modal
          className="modal-dialog-centered modal-lg proprietorUdyogAadhaarModal"
          isOpen={this.state.proprietorUdyogAadhaar}
          toggle={() => this.toggleModal("proprietorUdyogAadhaar")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("proprietorUdyogAadhaar")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.proprietorUdyogAadhaar} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Please upload your Udyog Aadhaar copy</h5>
                <p>Please upload front side</p>
              </div>
              <p className="mb-1">Enter Udyog Aadhar number</p>
              <div className="dv-GST">
                <input
                  type="text"
                  className="form-control"
                  id="txtaadharno-modal"
                  defaultValue=""
                  placeholder="Enter Udyog Aadhar number"
                  onBlur={this.handleUdyogAadhar}
                />

                {/* <button className="btn btn-gradient">Save</button> */}
              </div>
              {this.state.udhaarError && (
                <div>
                  {" "}
                  <small style={{ color: "red" }}>
                    Please enter valid Uaadhar.
                  </small>
                </div>
              )}
              {this.state.udyogErrorResponse && (
                <p className="err" style={{ textAlign: "left" }}>
                  There is some technical issue or invalid Udyog Aadhar number.
                </p>
              )}
              <div className="dv-upload-img">
                {/* <button className="upload-btn">Upload image</button> */}
                {this.state.proprietorUdyogAadhaarPreviewFront && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="proprietorUdyogAadhaarFileFront"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.proprietorUdyogAadhaarPreviewFront}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.proprietorUdyogAadhaarFileFront
                      ? this.state.proprietorUdyogAadhaarFileFront
                      : uploadImg
                  }
                />
                <label
                  id="lblproprietorUdyogAadhaarFileFront"
                  className="d-none"
                ></label>
              </div>
              {this.state.fileSizeError1 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              {/* <div className="row ad-upld">
                                <div className="col-md-6">
                                    <div className="dv-upload-img-small">
                                        <button className="upload-btn-small">Upload image</button>
                                        <input type="file" id="proprietorUdyogAadhaarFileFront" name="myfile" accept=".jpeg, .png, .jpg" onChange={this.proprietorUdyogAadhaarPreviewFront} />
                                        <img className="img-preview" src={this.state.proprietorUdyogAadhaarFileFront ? this.state.proprietorUdyogAadhaarFileFront : uploadImg} />
                                        <label id="lblproprietorUdyogAadhaarFileFront" className="d-none"></label>
                                    </div>
                                    <p className="text-center mod-txt">Front Side</p>
                                </div>
                                <div className="col-md-6">
                                    <div className="dv-upload-img-small">
                                        <button className="upload-btn-small">Upload image</button>
                                        <input type="file" id="proprietorUdyogAadhaarFileBack" name="myfile" accept=".jpeg, .png, .jpg" onChange={this.proprietorUdyogAadhaarPreviewBack} />
                                        <img className="img-preview" src={this.state.proprietorUdyogAadhaarFileBack ? this.state.proprietorUdyogAadhaarFileBack : uploadImg} />
                                        <label id="lblproprietorUdyogAadhaarFileBack" className="d-none"></label>
                                    </div>
                                    <p className="text-center mod-txt">Back Side</p>
                                </div>
                            </div>
                            <div className="filledDet">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="propUdyogAadhaarName">Name</label>
                                            <input type="text" className="form-control" id="propUdyogAadhaarName" placeholder="" disabled />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="propUdyogAadhaarNo">Aadhaar Card No.</label>
                                            <input type="text" className="form-control" id="propUdyogAadhaarNo" placeholder="" disabled />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="propUdyogAadhaarAddress">Address</label>
                                            <textarea className="form-control addtxtarea" name="" id="propUdyogAadhaarAddress" disabled></textarea>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group form-check m-2 px-0">
                                            <input type="checkbox" className="form-check-input cont-chk-inpt ml-0" id="chkAgreeAadhar" />
                                            <label className="form-check-label cont-chk ml-4 pl-2" htmlFor="chkAgreeAadhar">I have understood the purpose and importance of providing the aadhar details, therefore I am Voluntarily consent to provide the required details.
                                    </label>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {this.state.imageUploadedError2 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please enter ID no.
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "proprietorUdyogAadhaar")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        {/* proprietorFood Modal */}
        <Modal
          className="modal-dialog-centered modal-lg proprietorFoodModal"
          isOpen={this.state.proprietorFoodModal}
          toggle={() => this.toggleModal("proprietorFoodModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("proprietorFoodModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.proprietorFood} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Your Food Certificate</h5>
                <p>Please upload front side</p>
              </div>
              <p className="mb-1">Enter Food Certificate number</p>
              <div className="dv-GST">
                <input
                  type="text"
                  className="form-control"
                  id="txtfoodno-modal"
                  defaultValue=""
                  placeholder="Enter Food Certificate number"
                  onBlur={this.handleFSSAI}
                />

                {/* <button className="btn btn-gradient">Save</button> */}
              </div>
              {this.state.fssaiError && (
                <div>
                  <small style={{ color: "red" }}>
                    Please enter valid FSSAI.
                  </small>
                </div>
              )}
              {this.state.foodErrorResponse && (
                <p className="err" style={{ textAlign: "left" }}>
                  There is some technical issue or invalid FSSAI number.
                </p>
              )}
              <div className="dv-upload-img">
                {/* <button className="upload-btn">Upload image</button> */}
                {this.state.proprietorFoodFile && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="proprietorFood"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.proprietorFoodPreview}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.proprietorFoodFile
                      ? this.state.proprietorFoodFile
                      : uploadImg
                  }
                />
                <label id="lblproprietorFoodFile" className="d-none"></label>
              </div>
              {this.state.fileSizeError1 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {this.state.imageUploadedError2 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please enter ID no.
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "proprietorFoodModal")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>
        {/* partnerGstModal */}
        <Modal
          className="modal-dialog-centered modal-lg partnerGstModal"
          isOpen={this.state.partnerGstModal}
          toggle={() => this.toggleModal("partnerGstModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("partnerGstModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.partnerGst} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Your GST Certificate</h5>
                <p>Please upload front side</p>
              </div>
              <p className="mb-1">Enter GSTIN number</p>
              <div className="dv-GST">
                <input
                  type="text"
                  className="form-control"
                  id="txtgstno-modal"
                  placeholder="Enter GSTIN number"
                  onBlur={this.handleGSTIN}
                />

                {/* <button className="btn btn-gradient">Save</button> */}
              </div>
              {this.state.gstError && (
                <div>
                  {" "}
                  <small style={{ color: "red" }}>
                    Please enter valid GSTIN.
                  </small>
                </div>
              )}
              {this.state.GSTINErrorResponse && (
                <p className="err" style={{ textAlign: "left" }}>
                  {" "}
                  There is some technical issue or invalid GSTIN number.{" "}
                </p>
              )}
              <div className="dv-upload-img">
                {/* <button className="upload-btn">Upload image</button> */}
                {this.state.partnerGstFile && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="partnerGst"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.partnerGstPreview}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.partnerGstFile
                      ? this.state.partnerGstFile
                      : uploadImg
                  }
                />
                <label id="lblpartnerGstFile" className="d-none"></label>
              </div>
              {this.state.fileSizeError1 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {this.state.imageUploadedError2 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please enter ID no.
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) => this.handleCloseModal(e, "partnerGstModal")}
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        {/* partnerPanModal */}
        <Modal
          className="modal-dialog-centered modal-lg uploadModalPan"
          isOpen={this.state.partnerPanModal}
          toggle={() => this.toggleModal("partnerPanModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("partnerPanModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.partnerPan} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Your Company PAN Card Copy</h5>
                <p>Please upload front side</p>
              </div>
              {/* <p className="mb-1">Enter Pan Card number</p>
                            <div className="dv-GST">
                                <input type="text" className="form-control" id="txtpanno-modal" defaultValue="" placeholder="Enter Pan Card number" />
                            </div> */}
              <div className="dv-upload-img">
                {this.state.partnerPanFile && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="partnerPanFile"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.partnerPanPreview}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.partnerPanFile
                      ? this.state.partnerPanFile
                      : uploadImg
                  }
                />
                <label id="lblpartnerPanFile" className="d-none"></label>
              </div>
              {this.state.fileSizeError1 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              {/* <div className="filledDet">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="partnerPanName">Name</label>
                                            <input type="text" className="form-control" id="partnerPanName" placeholder="" disabled />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="partnerPanFName">Father Name</label>
                                            <input type="text" className="form-control" id="partnerPanFName" placeholder="" disabled />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="partnerPanNo">PAN No.</label>
                                            <input type="text" className="form-control" id="partnerPanNo" placeholder="" disabled />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="partnerPanDOB">Date of Birth</label>
                                            <input type="text" className="form-control" id="partnerPanDOB" placeholder="" disabled />
                                        </div>
                                    </div>
                                </div>
                            </div> */}
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) => this.handleCloseModal(e, "partnerPanModal")}
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        {/* partnerDeedModal */}
        <Modal
          className="modal-dialog-centered modal-lg partnerDeedModal"
          isOpen={this.state.partnerDeedModal}
          toggle={() => this.toggleModal("partnerDeedModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("partnerDeedModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.partnerDeed} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Please upload your Partnership Deed copy</h5>
              </div>
              <div className="row ad-upld">
                <div className="col-md-12">
                  <div className="dv-upload-img">
                    {/* <button className="upload-btn">Upload File</button> */}
                    {this.state.partnerDeedFile && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="partnerDeedFile"
                      name="myfile"
                      accept=".pdf, .docx, .doc"
                      onChange={this.partnerDeedPreview}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.partnerDeedFile ? documentImgIcon : uploadImg
                      }
                    />
                    <label>{this.state.deedFileName}</label>
                    <label id="lblpartnerDeedFile" className="d-none"></label>
                  </div>
                  {this.state.fileSizeError1 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                  <p className="note-text">
                    (Note: Please upload pdf/docx/doc and max-size:2MB file)
                  </p>
                </div>
              </div>
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload file
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "partnerDeedModal")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
            </form>
          </div>
        </Modal>

        {/* partnerCINModal */}
        <Modal
          className="modal-dialog-centered modal-lg partnerCINModal"
          isOpen={this.state.partnerCIN}
          toggle={() => this.toggleModal("partnerCIN")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("partnerCIN")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.partnerCIN} className="dv-upload">
              <div className="dv-upload-header">
                <h5>
                  Please upload your Corporate Identification number (CIN) copy
                </h5>
              </div>
              <p className="mb-1">Enter CIN number</p>
              <div className="dv-GST">
                <input
                  type="text"
                  className="form-control"
                  id="txtcinno-modal"
                  defaultValue=""
                  placeholder="Enter CIN number"
                  onBlur={this.handleCIN}
                />

                {/* <button className="btn btn-gradient">Save</button> */}
              </div>
              {this.state.cinError && (
                <div>
                  <small style={{ color: "red" }}>
                    Please enter valid CIN.
                  </small>
                </div>
              )}
              {this.state.CINErrorResponse && (
                <p className="err" style={{ textAlign: "left" }}>
                  {" "}
                  There is some technical issue or invalid CIN number.{" "}
                </p>
              )}
              <div className="row ad-upld">
                <div className="col-md-12">
                  <div className="dv-upload-img">
                    {/* <button className="upload-btn">Upload File</button> */}
                    {this.state.partnerCINFileFront && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="partnerCINFileFront"
                      name="myfile"
                      accept=".jpeg, .png, .jpg"
                      onChange={this.partnerCINPreviewFront}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.partnerCINFileFront
                          ? this.state.partnerCINFileFront
                          : uploadImg
                      }
                    />
                    <label
                      id="lblpartnerCINFileFront"
                      className="d-none"
                    ></label>
                  </div>
                  {this.state.fileSizeError1 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                  <p className="note-text">
                    (Note: Please upload jpeg/png/jpg and max-size:2MB image)
                  </p>
                </div>
              </div>
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {this.state.imageUploadedError2 && (
                <p className="err">Please enter ID no.</p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) => this.handleCloseModal(e, "partnerCIN")}
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        {/* partner Food certificate  */}
        <Modal
          className="modal-dialog-centered modal-lg partnerGstModal"
          isOpen={this.state.partnerFoodModal}
          toggle={() => this.toggleModal("partnerFoodModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("partnerFoodModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.partnerFood} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Your Food Certificate</h5>
                <p>Please upload front side</p>
              </div>
              <p className="mb-1">Enter Food certificate number</p>
              <div className="dv-GST">
                <input
                  type="text"
                  className="form-control"
                  id="txtfoodno-modal"
                  defaultValue=""
                  placeholder="Enter Food certificate number"
                  onBlur={this.handleFSSAI}
                />

                {/* <button className="btn btn-gradient">Save</button> */}
              </div>
              {this.state.fssaiError && (
                <div>
                  <small style={{ color: "red" }}>
                    Please enter valid FSSAI.
                  </small>
                </div>
              )}
              {this.state.foodErrorResponse && (
                <p className="err" style={{ textAlign: "left" }}>
                  There is some technical issue or invalid FSSAI number.
                </p>
              )}
              <div className="dv-upload-img">
                {/* <button className="upload-btn">Upload image</button> */}
                {this.state.partnerFoodFile && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="partnerFood"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.partnerFoodPreview}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.partnerFoodFile
                      ? this.state.partnerFoodFile
                      : uploadImg
                  }
                />
                <label id="lblpartnerFoodFile" className="d-none"></label>
              </div>
              {this.state.fileSizeError1 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {this.state.imageUploadedError2 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please enter ID no.
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "partnerFoodModal")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        {/* publicGstModal */}
        <Modal
          className="modal-dialog-centered modal-lg publicGstModal"
          isOpen={this.state.publicGstModal}
          toggle={() => this.toggleModal("publicGstModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("publicGstModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.publicGst} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Your GST Certificate</h5>
                <p>Please upload front side</p>
              </div>
              <p className="mb-1">Enter GSTIN number</p>
              <div className="dv-GST">
                <input
                  type="text"
                  className="form-control"
                  id="txtgstno-modal"
                  placeholder="Enter GSTIN number"
                  onBlur={this.handleGSTIN}
                />

                {/* <button className="btn btn-gradient">Save</button> */}
              </div>
              {this.state.gstError && (
                <div>
                  <small style={{ color: "red" }}>
                    Please enter valid GSTIN.
                  </small>
                </div>
              )}
              {this.state.GSTINErrorResponse && (
                <p className="err" style={{ textAlign: "left" }}>
                  {" "}
                  There is some technical issue or invalid GSTIN number.{" "}
                </p>
              )}
              <div className="dv-upload-img">
                {/* <button className="upload-btn">Upload image</button> */}
                {this.state.publicGstFile && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="publicGst"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.publicGstPreview}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.publicGstFile
                      ? this.state.publicGstFile
                      : uploadImg
                  }
                />
                <label id="lblpublicGstFile" className="d-none"></label>
              </div>
              {this.state.fileSizeError1 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {this.state.imageUploadedError2 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please enter ID no.
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) => this.handleCloseModal(e, "publicGstModal")}
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        {/* publicPanModal */}
        <Modal
          className="modal-dialog-centered modal-lg uploadModalPan"
          isOpen={this.state.publicPanModal}
          toggle={() => this.toggleModal("publicPanModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("publicPanModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.publicPan} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Your Company PAN Card Copy</h5>
                <p>Please upload front side</p>
              </div>
              {/* <p className="mb-1">Enter Pan Card number</p>
                            <div className="dv-GST">
                                <input type="text" className="form-control" id="txtpanno-modal" defaultValue="" placeholder="Enter Pan Card number" />
                            </div> */}
              <div className="dv-upload-img">
                {this.state.publicPanFile && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="publicPanFile"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.publicPanPreview}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.publicPanFile
                      ? this.state.publicPanFile
                      : uploadImg
                  }
                />
                <label id="lblpublicPanFile" className="d-none"></label>
              </div>
              {this.state.fileSizeError1 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              {/* <div className="filledDet">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="publicPanName">Name</label>
                                            <input type="text" className="form-control" id="publicPanName" placeholder="" disabled />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="publicPanFName">Father Name</label>
                                            <input type="text" className="form-control" id="publicPanFName" placeholder="" disabled />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="publicPanNo">PAN No.</label>
                                            <input type="text" className="form-control" id="publicPanNo" placeholder="" disabled />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="publicPanDOB">Date of Birth</label>
                                            <input type="text" className="form-control" id="publicPanDOB" placeholder="" disabled />
                                        </div>
                                    </div>
                                </div>
                            </div> */}
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) => this.handleCloseModal(e, "publicPanModal")}
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        {/* publicBRModal */}
        <Modal
          className="modal-dialog-centered modal-lg publicBRModal"
          isOpen={this.state.publicBRModal}
          toggle={() => this.toggleModal("publicBRModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("publicBRModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.publicBR} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Please upload your Board Resolution copy</h5>
              </div>
              <div className="row ad-upld">
                <div className="col-md-12">
                  <div className="dv-upload-img">
                    {/* <button className="upload-btn">Upload File</button> */}
                    {this.state.publicBRFile && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="publicBRFile"
                      name="myfile"
                      accept=".pdf, .docx, .doc"
                      onChange={this.publicBRPreview}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.publicBRFile ? documentImgIcon : uploadImg
                      }
                    />
                    <label>{this.state.brFileName}</label>
                    <label id="lblpublicBRFile" className="d-none"></label>
                  </div>
                  {this.state.fileSizeError1 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                  <p className="note-text">
                    (Note: Please upload pdf/docx/doc and max-size:2MB file)
                  </p>
                </div>
              </div>
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload file
                </p>
              )}
              <div className="btn-holder mt-3 text-center">
                {!this.state.submit ? (
                  <div className="btn-holder mt-3 text-center">
                    <button type="submit" className="btn btn-gradient bt-wd">
                      Submit{" "}
                      {this.state.isLoaded ? (
                        <Spinner
                          size="sm"
                          color="light"
                          className="btn-loader"
                        />
                      ) : null}
                    </button>
                  </div>
                ) : (
                  <div className="btn-holder mt-3 text-center">
                    <button
                      onClick={(e) => this.handleCloseModal(e, "publicBRModal")}
                      className="btn btn-gradient bt-wd"
                    >
                      Next
                    </button>
                  </div>
                )}
              </div>
            </form>
          </div>
        </Modal>

        {/* publicCINModal */}
        <Modal
          className="modal-dialog-centered modal-lg publicCINModal"
          isOpen={this.state.publicCINModal}
          toggle={() => this.toggleModal("publicCINModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("publicCINModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.publicCIN} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Please upload your CIN copy</h5>
                <p>Please upload front side</p>
              </div>
              <p className="mb-1">Enter CIN number</p>
              <div className="dv-GST">
                <input
                  type="text"
                  className="form-control"
                  id="txtcinno-modal"
                  defaultValue=""
                  placeholder="Enter CIN number"
                  onBlur={this.handleCIN}
                />

                {/* <button className="btn btn-gradient">Save</button> */}
              </div>
              {this.state.cinError && (
                <div>
                  {" "}
                  <small style={{ color: "red" }}>
                    Please enter valid CIN.
                  </small>
                </div>
              )}
              {this.state.CINErrorResponse && (
                <p className="err" style={{ textAlign: "left" }}>
                  {" "}
                  There is some technical issue or invalid CIN number.{" "}
                </p>
              )}
              <div className="row ad-upld">
                <div className="col-md-12">
                  <div className="dv-upload-img">
                    {/* <button className="upload-btn">Upload image</button> */}
                    {this.state.publicCINFileFront && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="publicCINFileFront"
                      name="myfile"
                      accept=".jpeg, .png, .jpg"
                      onChange={this.publicCINPreviewFront}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.publicCINFileFront
                          ? this.state.publicCINFileFront
                          : uploadImg
                      }
                    />
                    <label
                      id="lblpublicCINFileFront"
                      className="d-none"
                    ></label>
                  </div>
                  {this.state.fileSizeError1 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                  <p className="note-text">
                    (Note: Please upload jpeg/png/jpg and max-size:2MB image)
                  </p>
                  {/* <p className="text-center mod-txt">Front Side</p> */}
                </div>
              </div>
              {/* <div className="filledDet">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="txtname">Name</label>
                                            <input type="text" className="form-control" id="txtname" placeholder="" disabled />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="ftname">Father Name</label>
                                            <input type="text" className="form-control" id="ftname" placeholder="" disabled />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="txtno">CIN No.</label>
                                            <input type="text" className="form-control" id="txtno" placeholder="" disabled />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="txtdb">Date of Birth</label>
                                            <input type="text" className="form-control" id="txtdb" placeholder="" disabled />
                                        </div>
                                    </div>
                                </div>
                            </div> */}
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {this.state.imageUploadedError2 && (
                <p className="err">Please enter ID no.</p>
              )}

              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) => this.handleCloseModal(e, "publicCINModal")}
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        {/* publicDINModal */}
        <Modal
          className="modal-dialog-centered modal-lg publicDINModal"
          isOpen={this.state.publicDINModal}
          toggle={() => this.toggleModal("publicDINModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("publicDINModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.publicDIN} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Please upload your DIN copy</h5>
                <p>Please upload front side</p>
              </div>
              <p className="mb-1">Enter DIN number</p>
              <div className="dv-GST">
                <input
                  type="text"
                  className="form-control"
                  id="txtdinno-modal"
                  defaultValue=""
                  placeholder="Enter DIN number"
                  onBlur={this.handleDIN}
                />

                {/* <button className="btn btn-gradient">Save</button> */}
              </div>
              {this.state.dinError && (
                <div>
                  {" "}
                  <small style={{ color: "red" }}>
                    Please enter valid DIN.
                  </small>
                </div>
              )}
              {this.state.DINErrorResponse && (
                <p className="err" style={{ textAlign: "left" }}>
                  {" "}
                  There is some technical issue or invalid DIN number.{" "}
                </p>
              )}
              <div className="row ad-upld">
                <div className="col-md-12">
                  <div className="dv-upload-img">
                    {/* <button className="upload-btn">Upload image</button> */}
                    {this.state.publicDINFileFront && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="publicDINFileFront"
                      name="myfile"
                      accept=".jpeg, .png, .jpg"
                      onChange={this.publicDINPreviewFront}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.publicDINFileFront
                          ? this.state.publicDINFileFront
                          : uploadImg
                      }
                    />
                    <label
                      id="lblpublicDINFileFront"
                      className="d-none"
                    ></label>
                  </div>
                  {this.state.fileSizeError1 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                  <p className="note-text">
                    (Note: Please upload jpeg/png/jpg and max-size:2MB image)
                  </p>
                  {/* <p className="text-center mod-txt">Front Side</p> */}
                </div>
              </div>
              {/* <div className="filledDet">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="txtname">Name</label>
                                            <input type="text" className="form-control" id="txtname" placeholder="" disabled />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="ftname">Father Name</label>
                                            <input type="text" className="form-control" id="ftname" placeholder="" disabled />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="txtno">DIN No.</label>
                                            <input type="text" className="form-control" id="txtno" placeholder="" disabled />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="txtdb">Date of Birth</label>
                                            <input type="text" className="form-control" id="txtdb" placeholder="" disabled />
                                        </div>
                                    </div>
                                </div>
                            </div> */}
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {this.state.imageUploadedError2 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please enter ID no.
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) => this.handleCloseModal(e, "publicDINModal")}
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>
        {/* publicMOAModal */}
        <Modal
          className="modal-dialog-centered modal-lg publicMOAModal"
          isOpen={this.state.publicMOAModal}
          toggle={() => this.toggleModal("publicMOAModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("publicMOAModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.publicMOA} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Please Upload Your Memorandum Of Association Copy</h5>
              </div>
              <div className="row ad-upld">
                <div className="col-md-12">
                  <div className="dv-upload-img">
                    {/* <button className="upload-btn">Upload File</button> */}
                    {this.state.publicMOAFile && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="publicMOAFile"
                      name="myfile"
                      accept=".pdf, .docx, .doc"
                      onChange={this.publicMOAPreview}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.publicMOAFile ? documentImgIcon : uploadImg
                      }
                    />
                    <label>{this.state.moaFileName}</label>
                    <label id="lblpublicMOAFile" className="d-none"></label>
                  </div>
                  {this.state.fileSizeError1 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                  <p className="note-text">
                    (Note: Please upload pdf/docx/doc and max-size:2MB file)
                  </p>
                </div>
              </div>
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload file
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) => this.handleCloseModal(e, "publicMOAModal")}
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
            </form>
          </div>
        </Modal>
        {/* publicAOAModal */}
        <Modal
          className="modal-dialog-centered modal-lg publicAOAModal"
          isOpen={this.state.publicAOAModal}
          toggle={() => this.toggleModal("publicAOAModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("publicAOAModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.publicAOA} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Please Upload Your Article Of Associations Copy</h5>
              </div>
              <div className="row ad-upld">
                <div className="col-md-12">
                  <div className="dv-upload-img">
                    {/* <button className="upload-btn">Upload File</button> */}
                    {this.state.publicAOAFile && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="publicAOAFile"
                      name="myfile"
                      accept=".pdf, .docx, .doc"
                      onChange={this.publicAOAPreview}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.publicAOAFile ? documentImgIcon : uploadImg
                      }
                    />
                    <label>{this.state.aoaFileName}</label>
                    <label id="lblpublicAOAFile" className="d-none"></label>
                  </div>
                  {this.state.fileSizeError1 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                  <p className="note-text">
                    (Note: Please upload pdf/docx/doc and max-size:2MB file)
                  </p>
                </div>
              </div>
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload file
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) => this.handleCloseModal(e, "publicAOAModal")}
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
            </form>
          </div>
        </Modal>

        {/* publicUdyogAadhaarModal */}
        <Modal
          className="modal-dialog-centered modal-lg publicUdyogAadhaarModal"
          isOpen={this.state.publicUdyogAadhaarModal}
          toggle={() => this.toggleModal("publicUdyogAadhaarModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("publicUdyogAadhaarModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.publicUdyogAadhaar} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Please Upload Your Udyog Aadhaar Copy</h5>
                <p>Please upload front side</p>
              </div>
              <p className="mb-1">Enter Udyog Aadhar number</p>
              <div className="dv-GST">
                <input
                  type="text"
                  className="form-control"
                  id="txtaadharno-modal"
                  defaultValue=""
                  placeholder="Enter Udyog Aadhar number"
                  onBlur={this.handleUdyogAadhar}
                />

                {/* <button className="btn btn-gradient">Save</button> */}
              </div>
              {this.state.udhaarError && (
                <div>
                  {" "}
                  <small style={{ color: "red" }}>
                    Please enter valid Uaadhar.
                  </small>
                </div>
              )}
              {this.state.udyogErrorResponse && (
                <p className="err" style={{ textAlign: "left" }}>
                  There is some technical issue or invalid Udyog Aadhar number.
                </p>
              )}
              <div className="dv-upload-img">
                {/* <button className="upload-btn">Upload image</button> */}
                {this.state.publicUdyogAadhaarPreviewFront && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="publicUdyogAadhaarFileFront"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.publicUdyogAadhaarPreviewFront}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.publicUdyogAadhaarFileFront
                      ? this.state.publicUdyogAadhaarFileFront
                      : uploadImg
                  }
                />
                <label
                  id="lblpublicUdyogAadhaarFileFront"
                  className="d-none"
                ></label>
              </div>
              {this.state.fileSizeError1 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              {/* <div className="row ad-upld">
                                <div className="col-md-6">
                                    <div className="dv-upload-img-small">
                                        <button className="upload-btn-small">Upload image</button>
                                        <input type="file" id="publicUdyogAadhaarFileFront" name="myfile" accept=".jpeg, .png, .jpg" onChange={this.publicUdyogAadhaarPreviewFront} />
                                        <img className="img-preview" src={this.state.publicUdyogAadhaarFileFront ? this.state.publicUdyogAadhaarFileFront : uploadImg} />
                                        <label id="lblpublicUdyogAadhaarFileFront" className="d-none"></label>
                                    </div>
                                    <p className="text-center mod-txt">Front Side</p>
                                </div>
                                <div className="col-md-6">
                                    <div className="dv-upload-img-small">
                                        <button className="upload-btn-small">Upload image</button>
                                        <input type="file" id="publicUdyogAadhaarFileBack" name="myfile" accept=".jpeg, .png, .jpg" onChange={this.publicUdyogAadhaarPreviewBack} />
                                        <img className="img-preview" src={this.state.publicUdyogAadhaarFileBack ? this.state.publicUdyogAadhaarFileBack : uploadImg} />
                                        <label id="lblpublicUdyogAadhaarFileBack" className="d-none"></label>
                                    </div>
                                    <p className="text-center mod-txt">Back Side</p>
                                </div>
                            </div>
                            <div className="filledDet">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="publicUdyogAadhaarName">Name</label>
                                            <input type="text" className="form-control" id="publicUdyogAadhaarName" placeholder="" disabled />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="publicUdyogAadhaarNo">Aadhaar Card No.</label>
                                            <input type="text" className="form-control" id="publicUdyogAadhaarNo" placeholder="" disabled />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="publicUdyogAadhaarAddress">Address</label>
                                            <textarea className="form-control addtxtarea" name="" id="publicUdyogAadhaarAddress" disabled></textarea>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group form-check m-2 px-0">
                                            <input type="checkbox" className="form-check-input cont-chk-inpt ml-0" id="chkAgreeAadhar" />
                                            <label className="form-check-label cont-chk ml-4 pl-2" htmlFor="chkAgreeAadhar">I have understood the purpose and importance of providing the aadhar details, therefore I am Voluntarily consent to provide the required details.
                                    </label>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {this.state.imageUploadedError2 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please enter ID no.
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) =>
                      this.handleCloseModal(e, "publicUdyogAadhaarModal")
                    }
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        {/* Public Food certificate */}
        <Modal
          className="modal-dialog-centered modal-lg publicFoodModal"
          isOpen={this.state.publicFoodModal}
          toggle={() => this.toggleModal("publicFoodModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("publicFoodModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.publicFood} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Your Food Certificate</h5>
                <p>Please upload front side</p>
              </div>
              <p className="mb-1">Enter Food certificate number</p>
              <div className="dv-GST">
                <input
                  type="text"
                  className="form-control"
                  id="txtfoodno-modal"
                  defaultValue=""
                  placeholder="Enter Food certificate number"
                  onBlur={this.handleFSSAI}
                />

                {/* <button className="btn btn-gradient">Save</button> */}
              </div>
              {this.state.fssaiError && (
                <div>
                  {" "}
                  <small style={{ color: "red" }}>
                    Please enter valid FSSAI.
                  </small>
                </div>
              )}
              {this.state.foodErrorResponse && (
                <p className="err" style={{ textAlign: "left" }}>
                  There is some technical issue or invalid FSSAI number.
                </p>
              )}
              <div className="dv-upload-img">
                {/* <button className="upload-btn">Upload image</button> */}
                {this.state.publicFoodFile && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="publicFood"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.publicFoodPreview}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.publicFoodFile
                      ? this.state.publicFoodFile
                      : uploadImg
                  }
                />
                <label id="lblpublicFoodFile" className="d-none"></label>
              </div>
              {this.state.fileSizeError1 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {this.state.imageUploadedError2 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please enter ID no.
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) => this.handleCloseModal(e, "publicFoodModal")}
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        {/* socialGstModal */}
        <Modal
          className="modal-dialog-centered modal-lg socialGstModal"
          isOpen={this.state.socialGstModal}
          toggle={() => this.toggleModal("socialGstModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("socialGstModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.socialGst} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Your GST Certificate</h5>
                <p>Please upload front side</p>
              </div>
              <p className="mb-1">Enter GSTIN number</p>
              <div className="dv-GST">
                <input
                  type="text"
                  className="form-control"
                  id="txtgstno-modal"
                  placeholder="Enter GSTIN number"
                  onBlur={this.handleGSTIN}
                />

                {/* <button className="btn btn-gradient">Save</button> */}
              </div>
              {this.state.gstError && (
                <div>
                  {" "}
                  <small style={{ color: "red" }}>
                    Please enter valid GSTIN.
                  </small>
                </div>
              )}
              {this.state.GSTINErrorResponse && (
                <p className="err" style={{ textAlign: "left" }}>
                  {" "}
                  There is some technical issue or invalid GSTIN number.{" "}
                </p>
              )}
              <div className="dv-upload-img">
                {/* <button className="upload-btn">Upload image</button> */}
                {this.state.socialGstFile && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="socialGst"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.socialGstPreview}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.socialGstFile
                      ? this.state.socialGstFile
                      : uploadImg
                  }
                />
                <label id="lblsocialGstFile" className="d-none"></label>
              </div>
              {this.state.fileSizeError1 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {this.state.imageUploadedError2 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please enter ID no.
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) => this.handleCloseModal(e, "socialGstModal")}
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        {/* socialPanModal */}
        <Modal
          className="modal-dialog-centered modal-lg uploadModalPan"
          isOpen={this.state.socialPanModal}
          toggle={() => this.toggleModal("socialPanModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("socialPanModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.socialPan} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Your Company PAN Card Copy</h5>
                <p>Please upload front side</p>
              </div>
              {/* <p className="mb-1">Enter Pan Card number</p>
                            <div className="dv-GST">
                                <input type="text" className="form-control" id="txtpanno-modal" defaultValue="" placeholder="Enter Pan Card number" />
                                
                            </div> */}
              <div className="dv-upload-img">
                {this.state.socialPanFile && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="socialPanFile"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.socialPanPreview}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.socialPanFile
                      ? this.state.socialPanFile
                      : uploadImg
                  }
                />
                <label id="lblsocialPanFile" className="d-none"></label>
              </div>
              {this.state.fileSizeError1 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              {/* <div className="filledDet">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="socialPanName">Name</label>
                                            <input type="text" className="form-control" id="socialPanName" placeholder="" disabled />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="socialPanFName">Father Name</label>
                                            <input type="text" className="form-control" id="socialPanFName" placeholder="" disabled />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="socialPanNo">PAN No.</label>
                                            <input type="text" className="form-control" id="txtno" placeholder="" disabled />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="socialPanDOB">Date of Birth</label>
                                            <input type="text" className="form-control" id="socialPanDOB" placeholder="" disabled />
                                        </div>
                                    </div>
                                </div>
                            </div> */}
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) => this.handleCloseModal(e, "socialPanModal")}
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        {/* socialTACModal */}
        <Modal
          className="modal-dialog-centered modal-lg socialTACModal"
          isOpen={this.state.socialTACModal}
          toggle={() => this.toggleModal("socialTACModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("socialTACModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.socialTAC} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Please Upload Your Trust Act Certificate Copy</h5>
              </div>
              <div className="row ad-upld">
                <div className="col-md-12">
                  <div className="dv-upload-img">
                    {/* <button className="upload-btn">Upload File</button> */}
                    {this.state.socialTACFile && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="socialTACFile"
                      name="myfile"
                      accept=".pdf, .docx, .doc"
                      onChange={this.socialTACPreview}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.socialTACFile ? documentImgIcon : uploadImg
                      }
                    />
                    <label>{this.state.tacFileName}</label>
                    <label id="lblsocialTACFile" className="d-none"></label>
                  </div>
                  {this.state.fileSizeError1 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                  <p className="note-text">
                    (Note: Please upload pdf/docx/doc and max-size:2MB file)
                  </p>
                </div>
              </div>
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload file
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) => this.handleCloseModal(e, "socialTACModal")}
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
            </form>
          </div>
        </Modal>
        {/* socialBRModal */}
        <Modal
          className="modal-dialog-centered modal-lg socialBRModal"
          isOpen={this.state.socialBRModal}
          toggle={() => this.toggleModal("socialBRModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("socialBRModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.socialBR} className="dv-upload">
              <div className="dv-upload-header">
                <h5>
                  Please Upload Your Authorization Letter Or Board Resolution
                  Copy
                </h5>
              </div>
              <div className="row ad-upld">
                <div className="col-md-12">
                  <div className="dv-upload-img">
                    {/* <button className="upload-btn">Upload File</button> */}
                    {this.state.socialBRFile && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="socialBRFile"
                      name="myfile"
                      accept=".pdf, .docx, .doc"
                      onChange={this.socialBRPreview}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.socialBRFile ? documentImgIcon : uploadImg
                      }
                    />
                    <label>{this.state.brFileName}</label>

                    <label id="lblsocialBRFile" className="d-none"></label>
                  </div>
                  {this.state.fileSizeError1 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                  <p className="note-text">
                    (Note: Please upload pdf/docx/doc and max-size:2MB file)
                  </p>
                </div>
              </div>
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload file
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) => this.handleCloseModal(e, "socialBRModal")}
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
            </form>
          </div>
        </Modal>
        {/* socialDeedModal */}
        <Modal
          className="modal-dialog-centered modal-lg socialDeedModal"
          isOpen={this.state.socialDeedModal}
          toggle={() => this.toggleModal("socialDeedModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("socialDeedModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.socialDeed} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Please Upload Your Trust Deed Copy</h5>
              </div>
              <div className="row ad-upld">
                <div className="col-md-12">
                  <div className="dv-upload-img">
                    {/* <button className="upload-btn">Upload File</button> */}
                    {this.state.socialDeedFile && (
                      <>
                        <button
                          className="upload-btn"
                          style={{ fontSize: "0.8rem", color: "#525f7f" }}
                        >
                          Replace
                        </button>
                        <i
                          className="fa fa-repeat"
                          style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                          aria-hidden="true"
                        ></i>
                      </>
                    )}
                    <input
                      type="file"
                      id="socialDeedFile"
                      name="myfile"
                      accept=".pdf, .docx, .doc"
                      onChange={this.socialDeedPreview}
                    />
                    <img
                      className="img-preview"
                      src={
                        this.state.socialDeedFile ? documentImgIcon : uploadImg
                      }
                    />
                    <label>{this.state.deedFileName}</label>
                    <label id="lblsocialDeedFile" className="d-none"></label>
                  </div>
                  {this.state.fileSizeError1 && (
                    <>
                      <small className="err">
                        {this.state.fileSizeErrorMsg}
                      </small>
                      <br />
                      <small className="err">
                        Please upload max-size:2MB image.
                      </small>
                    </>
                  )}
                  <p className="note-text">
                    (Note: Please upload pdf/docx/doc and max-size:2MB file)
                  </p>
                </div>
              </div>
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload file
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) => this.handleCloseModal(e, "socialDeedModal")}
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
            </form>
          </div>
        </Modal>

        {/* social Food certificate */}
        <Modal
          className="modal-dialog-centered modal-lg socialFoodModal"
          isOpen={this.state.socialFoodModal}
          toggle={() => this.toggleModal("socialFoodModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("socialFoodModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <form onSubmit={this.socialFood} className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Your Food Certificate</h5>
                <p>Please upload front side</p>
              </div>
              <p className="mb-1">Enter Food certificate number</p>
              <div className="dv-GST">
                <input
                  type="text"
                  className="form-control"
                  id="txtfoodno-modal"
                  defaultValue=""
                  placeholder="Enter Food certificate number"
                  onBlur={this.handleFSSAI}
                />

                {/* <button className="btn btn-gradient">Save</button> */}
              </div>
              {this.state.fssaiError && (
                <div>
                  {" "}
                  <small style={{ color: "red" }}>
                    Please enter valid FSSAI.
                  </small>
                </div>
              )}
              {this.state.foodErrorResponse && (
                <p className="err" style={{ textAlign: "left" }}>
                  There is some technical issue or invalid FSSAI number.
                </p>
              )}
              <div className="dv-upload-img">
                {/* <button className="upload-btn">Upload image</button> */}
                {this.state.socialFoodFile && (
                  <>
                    <button
                      className="upload-btn"
                      style={{ fontSize: "0.8rem", color: "#525f7f" }}
                    >
                      Replace
                    </button>
                    <i
                      className="fa fa-repeat"
                      style={{ fontSize: "1.4rem", marginTop: "1rem" }}
                      aria-hidden="true"
                    ></i>
                  </>
                )}
                <input
                  type="file"
                  id="socialFood"
                  name="myfile"
                  accept=".jpeg, .png, .jpg"
                  onChange={this.socialFoodPreview}
                />
                <img
                  className="img-preview"
                  src={
                    this.state.socialFoodFile
                      ? this.state.socialFoodFile
                      : uploadImg
                  }
                />
                <label id="lblsocialFoodFile" className="d-none"></label>
              </div>
              {this.state.fileSizeError1 && (
                <>
                  <small className="err">{this.state.fileSizeErrorMsg}</small>
                  <br />
                  <small className="err">
                    Please upload max-size:2MB image.
                  </small>
                </>
              )}
              <p className="note-text">
                (Note: Please upload jpeg/png/jpg and max-size:2MB image)
              </p>
              {this.state.imageUploadedError1 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please upload image
                </p>
              )}
              {this.state.imageUploadedError2 && (
                <p className="err" style={{ textAlign: "center" }}>
                  Please enter ID no.
                </p>
              )}
              {!this.state.submit ? (
                <div className="btn-holder mt-3 text-center">
                  <button
                    type="submit"
                    className={
                      this.state.isLoaded
                        ? `btn btn-gradient bt-wd disable-btn`
                        : `btn btn-gradient bt-wd`
                    }
                    disabled={this.state.isLoaded}
                  >
                    Submit{" "}
                    {this.state.isLoaded ? (
                      <Spinner size="sm" color="light" className="btn-loader" />
                    ) : null}
                  </button>
                </div>
              ) : (
                <div className="btn-holder mt-3 text-center">
                  <button
                    onClick={(e) => this.handleCloseModal(e, "socialFoodModal")}
                    className="btn btn-gradient bt-wd"
                  >
                    Next
                  </button>
                </div>
              )}
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </form>
          </div>
        </Modal>

        <Modal
          className="modal-dialog-centered modal-lg uploadModalPdf"
          isOpen={this.state.uploadModalPdf}
          toggle={() => this.toggleModal("uploadModalPdf")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("uploadModalPdf")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button>
            <div className="dv-upload">
              <div className="dv-upload-header">
                <h5>Upload Document</h5>
                <p>Upload document in PDF format</p>
              </div>
              <div className="dv-upload-img">
                <p>Upload PDF</p>
              </div>
              <div className="btn-holder mt-3 text-center">
                <button className="btn btn-gradient bt-wd w-100">Submit</button>
              </div>
              {/* <div className="dv-upload-progress">
                                <p>Uploaded image is getting veriﬁed , Please wait.</p>
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped bg-success" role="progressbar" style={{width: "80%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}
            </div>
          </div>
        </Modal>
        <Modal
          className="modal-dialog-centered modal-lg loginModal"
          isOpen={this.state.loginModal}
          toggle={() => this.toggleModal("loginModal")}
          backdrop={false}
          keyboard={false}
        >
          <div className="modal-body p-4">
            {/* <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("loginModal")}
            >
              <span aria-hidden={true} className="close-btn-align">
                ×
              </span>
            </button> */}
            <h5 style={{ textAlign: "center" }}>
              Session Expired, Please Login to continue
            </h5>
            <div className="btn-holder mt-3 text-center">
              <button
                onClick={this.handleLogin}
                className="btn btn-gradient bt-wd"
              >
                Login
              </button>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

export default BusinessDoc;
